// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/mfg-close.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.mobile-menu {
  transition: var(--default-transition);
}
body.navbar-collapse-show.mobile-menu {
  transition-delay: 0.3s;
}
body.navbar-collapse-show header.reverse-scroll.sticky-header {
  transform: translateY(0);
}

header .top-bar {
  transition: var(--default-transition);
}
header .dropdown .dropdown-menu {
  opacity: 0;
  padding: 15px;
  visibility: hidden;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
  transition: var(--default-transition);
}
header .dropdown .dropdown-menu a {
  display: flex;
  align-items: center;
}
header .dropdown .dropdown-menu a span {
  display: inline-block;
  margin-right: 10px;
}
header .dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
}
header .header-search-iconbar > a {
  color: #232323;
  cursor: pointer;
  transition: var(--default-transition);
}
header .header-search-iconbar > a:hover {
  color: rgba(0, 0, 0, 0.6);
}
header .header-language {
  position: relative;
}
header .header-language > a {
  color: #232323;
  cursor: pointer;
  transition: var(--default-transition);
}
header .header-language > a:hover {
  color: rgba(0, 0, 0, 0.6);
}
header .header-language .dropdown-menu a {
  font-size: 12px;
  line-height: 30px;
  padding: 2px 0;
  color: #828282;
  transition: var(--default-transition);
}
header .header-language .dropdown-menu a:hover {
  color: #232323;
}
header .header-language .dropdown-menu a span {
  width: 16px;
  height: 16px;
  display: inline-block;
  margin: 0 10px 0 5px;
}
header .header-language .dropdown-menu.show {
  opacity: 1;
  visibility: visible;
}
header .header-cart-icon {
  position: relative;
}
header .header-cart-icon > a {
  color: #232323;
  transition: var(--default-transition);
}
header .header-cart-icon .cart-item-list {
  left: auto;
  right: 0;
  border-radius: 4px;
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 250px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
}
header .header-cart-icon .cart-item-list .cart-item {
  display: flex;
  position: relative;
  border-color: #ededed;
  border-bottom-width: 1px;
  padding: 17px;
}
header .header-cart-icon .cart-item-list .cart-item:last-child {
  border-bottom: none;
  border-radius: 0 0 6px 6px;
}
header .header-cart-icon .cart-item-list .cart-item > .close {
  font-size: 16px;
  line-height: 15px;
  position: absolute;
  color: #838383;
  right: 15px;
  top: 15px;
  font-weight: 400;
  transition: var(--default-transition);
}
header .header-cart-icon .cart-item-list .cart-item > .close:hover {
  color: #232323;
}
header .header-cart-icon .cart-item-list .cart-item .product-image {
  max-width: 50px;
  width: 30%;
  display: inline-block;
}
header .header-cart-icon .cart-item-list .cart-item .product-detail {
  display: inline-block;
  width: 70%;
  padding-left: 15px;
}
header .header-cart-icon .cart-item-list .cart-item .product-detail > a {
  display: inline-block;
  color: #232323;
  font-size: 12px;
  line-height: 16px;
}
header .header-cart-icon .cart-item-list .cart-item .product-detail .item-ammount {
  display: block;
  font-size: 11px;
  line-height: 14px;
  color: #828282;
  line-height: 1.5;
}
header .header-cart-icon .cart-item-list .cart-total {
  flex-direction: column;
  background-color: #f7f7f7;
}
header .header-cart-icon .cart-item-list .cart-total .btn {
  display: block;
  width: 100%;
  margin-top: 4px;
  margin-bottom: 4px;
}
header .header-cart-icon > a:hover {
  color: rgba(35, 35, 35, 0.6);
  cursor: pointer;
}
header [class^=container-] [class*=" col-"],
header [class^=container-] [class^=col-],
header [class*=" container-"] [class*=" col-"],
header [class*=" container-"] [class^=col-] {
  padding-right: 15px;
  padding-left: 15px;
  position: relative;
}
header .nav-item {
  position: relative;
  font-family: var(--alt-font);
  font-size: 14px;
  line-height: 20px;
}
header .nav-item > i {
  display: none;
}
header .nav-item:hover .megamenu {
  opacity: 1;
  visibility: visible;
}
header .nav-item:hover > .simple-dropdown-menu {
  opacity: 1;
  visibility: visible;
}
header .nav-item:hover > .simple-dropdown-menu > li:hover > .simple-dropdown-menu {
  opacity: 1;
  visibility: visible;
}
header .nav-item:hover > .simple-dropdown-menu > li:hover > .simple-dropdown-menu > li:hover > .simple-dropdown-menu {
  opacity: 1;
  visibility: visible;
}
header .nav-item .simple-dropdown-menu {
  background-color: #fff;
  box-sizing: border-box;
  z-index: 10;
  left: 0;
  top: 100%;
  position: absolute;
  font-weight: 500;
  font-size: 13px;
  opacity: 0;
  visibility: hidden;
  line-height: 20px;
  width: 240px;
  padding: 25px 0;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 0;
  transition: none;
}
header .nav-item .simple-dropdown-menu li {
  padding: 9px 0 9px 35px;
  position: relative;
  display: block;
}
header .nav-item .simple-dropdown-menu li > .nav-link {
  cursor: pointer;
  padding: 0;
  display: block;
}
header .nav-item .simple-dropdown-menu li > .nav-link > i {
  top: 50%;
  margin-top: 0;
  position: absolute;
  text-align: center;
  transform: translateY(-50%);
  display: inline-block;
  right: 23px;
  font-size: 12px;
  height: 20px;
  width: 20px;
  line-height: 20px;
  transition: var(--default-transition);
}
header .nav-item .simple-dropdown-menu li > .nav-link:hover {
  color: #232323;
}
header .nav-item .simple-dropdown-menu li > .simple-dropdown-menu {
  transform: translateX(0);
  top: 0;
  left: 100%;
}
header .nav-item .simple-dropdown-menu li > .simple-dropdown-menu.menu-left {
  right: 100%;
  left: auto !important;
}
header .nav-item .simple-dropdown-menu .simple-dropdown.active > .nav-link {
  color: #232323;
}
header .nav-item .nav-link {
  color: #828282;
}
header .nav-item .nav-link.active {
  color: #232323;
}
header .navbar-nav {
  display: flex;
  justify-content: center;
}
header .navbar-nav > .nav-item > .nav-link {
  padding: 30px 0;
  margin: 0 18px;
  word-break: normal;
  font-weight: 500;
  color: #232323;
  transition: var(--default-transition);
}
header .navbar-nav > .nav-item.active > .nav-link {
  opacity: 0.7;
}
header .navbar-nav .megamenu {
  box-sizing: border-box;
  background-color: #fff;
  z-index: 10;
  top: 100%;
  position: absolute;
  left: 0;
  transform: inherit;
  opacity: 0;
  visibility: hidden;
  padding: 60px 80px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 0;
  transition: 0s;
}
header .navbar-nav .megamenu ul {
  padding-right: 90px;
}
header .navbar-nav .megamenu ul .title {
  color: #232323;
}
header .navbar-nav .megamenu ul:last-child {
  padding-right: 50px;
}
@media (max-width: var(--lg)) {
  header .navbar-nav .megamenu ul {
    padding-right: 75px;
  }
}
header .navbar-nav .megamenu .nav-item .nav-link {
  display: flex;
  overflow: hidden;
  position: relative;
  padding: 0;
  font-family: var(--alt-font);
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  align-items: center;
  white-space: nowrap;
  color: #828282;
  margin: 0 0 5px 0;
  line-height: 30px;
  transition: var(--default-transition);
}
header .navbar-nav .megamenu .nav-item .nav-link:hover {
  color: #232323;
}
header .navbar-nav .megamenu .nav-item.active > .nav-link {
  color: #232323;
}
@media (max-width: var(--lg)) {
  header .navbar-nav .megamenu {
    padding: 35px 50px 40px;
  }
}
header .navbar-nav .submenu .nav-link {
  padding: 0;
}
header .navbar-nav .submenu .nav-link:hover {
  color: #232323;
}
header .navbar-brand img {
  max-height: 36px;
}
header .navbar-brand .default-logo {
  visibility: visible;
  opacity: 1;
  width: auto;
  transition-duration: 0.5s;
}
header .navbar-brand .alt-logo {
  visibility: hidden;
  opacity: 0;
  width: 0;
  transition-duration: 0.5s;
}
header .navbar-brand .mobile-logo {
  visibility: hidden;
  opacity: 0;
  width: 0;
  transition-duration: 0.5s;
}
header .navbar-dark .navbar-nav > .nav-item > .nav-link,
header .navbar-lg-dark .navbar-nav > .nav-item > .nav-link,
header .navbar-md-dark .navbar-nav > .nav-item > .nav-link,
header .navbar-sm-dark .navbar-nav > .nav-item > .nav-link,
header .navbar-xs-dark .navbar-nav > .nav-item > .nav-link,
header .navbar-xl-dark .navbar-nav > .nav-item > .nav-link,
header .navbar-xxl-dark .navbar-nav > .nav-item > .nav-link {
  color: #fff;
}
header .navbar-dark .navbar-nav > .nav-item > .nav-link:hover,
header .navbar-lg-dark .navbar-nav > .nav-item > .nav-link:hover,
header .navbar-md-dark .navbar-nav > .nav-item > .nav-link:hover,
header .navbar-sm-dark .navbar-nav > .nav-item > .nav-link:hover,
header .navbar-xs-dark .navbar-nav > .nav-item > .nav-link:hover,
header .navbar-xl-dark .navbar-nav > .nav-item > .nav-link:hover,
header .navbar-xxl-dark .navbar-nav > .nav-item > .nav-link:hover {
  opacity: 0.6;
}
header .navbar-dark .header-search-iconbar > a,
header .navbar-dark .header-language > a,
header .navbar-dark .header-cart-icon > a,
header .navbar-lg-dark .header-search-iconbar > a,
header .navbar-lg-dark .header-language > a,
header .navbar-lg-dark .header-cart-icon > a,
header .navbar-md-dark .header-search-iconbar > a,
header .navbar-md-dark .header-language > a,
header .navbar-md-dark .header-cart-icon > a,
header .navbar-sm-dark .header-search-iconbar > a,
header .navbar-sm-dark .header-language > a,
header .navbar-sm-dark .header-cart-icon > a,
header .navbar-xs-dark .header-search-iconbar > a,
header .navbar-xs-dark .header-language > a,
header .navbar-xs-dark .header-cart-icon > a,
header .navbar-xl-dark .header-search-iconbar > a,
header .navbar-xl-dark .header-language > a,
header .navbar-xl-dark .header-cart-icon > a,
header .navbar-xxl-dark .header-search-iconbar > a,
header .navbar-xxl-dark .header-language > a,
header .navbar-xxl-dark .header-cart-icon > a {
  color: #fff;
  display: inline-block;
  vertical-align: middle;
  min-height: 20px;
  width: 20px;
}
header .navbar-dark .header-search-iconbar > a:hover,
header .navbar-dark .header-language > a:hover,
header .navbar-dark .header-cart-icon > a:hover,
header .navbar-lg-dark .header-search-iconbar > a:hover,
header .navbar-lg-dark .header-language > a:hover,
header .navbar-lg-dark .header-cart-icon > a:hover,
header .navbar-md-dark .header-search-iconbar > a:hover,
header .navbar-md-dark .header-language > a:hover,
header .navbar-md-dark .header-cart-icon > a:hover,
header .navbar-sm-dark .header-search-iconbar > a:hover,
header .navbar-sm-dark .header-language > a:hover,
header .navbar-sm-dark .header-cart-icon > a:hover,
header .navbar-xs-dark .header-search-iconbar > a:hover,
header .navbar-xs-dark .header-language > a:hover,
header .navbar-xs-dark .header-cart-icon > a:hover,
header .navbar-xl-dark .header-search-iconbar > a:hover,
header .navbar-xl-dark .header-language > a:hover,
header .navbar-xl-dark .header-cart-icon > a:hover,
header .navbar-xxl-dark .header-search-iconbar > a:hover,
header .navbar-xxl-dark .header-language > a:hover,
header .navbar-xxl-dark .header-cart-icon > a:hover {
  color: rgba(255, 255, 255, 0.6);
}
header .navbar-dark .navbar-toggler .navbar-toggler-line,
header .navbar-lg-dark .navbar-toggler .navbar-toggler-line,
header .navbar-md-dark .navbar-toggler .navbar-toggler-line,
header .navbar-sm-dark .navbar-toggler .navbar-toggler-line,
header .navbar-xs-dark .navbar-toggler .navbar-toggler-line,
header .navbar-xl-dark .navbar-toggler .navbar-toggler-line,
header .navbar-xxl-dark .navbar-toggler .navbar-toggler-line {
  background-color: #fff;
}
header .menu-dark .megamenu {
  background-color: #232323;
}
header .menu-dark .megamenu ul .title {
  color: #fff;
}
header .menu-dark .megamenu .nav-item .nav-link:hover {
  color: #fff;
}
header .menu-dark .megamenu .nav-item.active .nav-link {
  color: #fff;
}
header .menu-dark .simple-dropdown-menu,
header .menu-dark .dropdown-menu {
  background-color: #232323;
}
header .menu-dark .simple-dropdown-menu > li .nav-link,
header .menu-dark .dropdown-menu > li .nav-link {
  transition: var(--default-transition);
}
header .menu-dark .simple-dropdown-menu > li .nav-link:hover,
header .menu-dark .dropdown-menu > li .nav-link:hover {
  color: #fff;
}
header .menu-dark .simple-dropdown-menu > li a,
header .menu-dark .dropdown-menu > li a {
  transition: var(--default-transition);
}
header .menu-dark .simple-dropdown-menu > li a:hover,
header .menu-dark .dropdown-menu > li a:hover {
  color: #fff;
}
header .collapsible-menu {
  font-family: var(--alt-font);
}
header .collapsible-menu .accordion-item {
  border: none;
  background-color: transparent;
}
header .collapsible-menu .accordion-item:hover > .accordion-header .accordion-button, header .collapsible-menu .accordion-item.active > .accordion-header .accordion-button {
  color: rgba(0, 0, 0, 0.6);
}
header .collapsible-menu .accordion-item .img-wrapper {
  border-style: none;
  display: none;
}
header .collapsible-menu .accordion-item .accordion-header .accordion-button {
  font-family: var(--alt-font);
  font-size: 20px;
  line-height: 1.5;
  color: #232323;
  padding: 13px 0;
}
header .collapsible-menu .accordion-item .accordion-header .accordion-button::after {
  overflow: hidden;
  display: none;
}
header .collapsible-menu .accordion-item .accordion-header .accordion-button:hover span,
header .collapsible-menu .accordion-item .accordion-header .accordion-button:hover a {
  transition: all 0.3s ease-in-out;
}
header .collapsible-menu .accordion-item .accordion-header .accordion-button .icon {
  display: inline-block;
  margin-left: auto;
  position: relative;
  width: 30px;
  height: 30px;
}
header .collapsible-menu .accordion-item .accordion-header .accordion-button .icon:before, header .collapsible-menu .accordion-item .accordion-header .accordion-button .icon:after {
  background-color: #232323;
  position: absolute;
  top: 50%;
  content: "";
  width: 11px;
  height: 1px;
  left: 10px;
  transition: var(--default-transition);
}
header .collapsible-menu .accordion-item .accordion-header .accordion-button .icon::after {
  background-image: none;
  transform: rotate(90deg);
}
header .collapsible-menu .accordion-item .accordion-header .accordion-button:not(.collapsed) {
  box-shadow: none;
  background-color: transparent;
}
header .collapsible-menu .accordion-item .accordion-header .accordion-button:not(.collapsed) > .icon::after {
  transform: rotate(0deg);
}
header .collapsible-menu .accordion-item .accordion-header .accordion-button:not(.collapsed) > .icon:before {
  background-color: transparent;
}
header .collapsible-menu .accordion-item .accordion-collapse .accordion-body {
  color: rgba(0, 0, 0, 0.6);
  padding: 5px 0;
  font-size: 13px;
  line-height: 22px;
}
header .collapsible-menu .accordion-item .accordion-collapse .accordion-body i {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}
header .collapsible-menu .accordion-item .accordion-collapse .accordion-body .accordion-button {
  font-size: 13px;
  padding: 0;
  line-height: 30px;
}
header .collapsible-menu .menu-list {
  padding-left: 15px;
}
header .collapsible-menu .menu-list .menu-list-item {
  line-height: 30px;
}
header .collapsible-menu .menu-list .menu-list-item a {
  color: rgba(0, 0, 0, 0.6);
}
header .collapsible-menu .menu-list .menu-list-item a:hover {
  color: rgba(0, 0, 0, 0.6);
}
header .collapsible-menu .menu-list .menu-list-item.active a {
  color: rgba(0, 0, 0, 0.3);
}
header .collapsible-menu .megamenu .accordion .accordion-item {
  border: 0px !important;
}
header .collapsible-menu .megamenu .accordion .accordion-item:hover .accordion-header .accordion-button {
  color: #828282 !important;
}
header .collapsible-menu .single-dropdown a.menu-link {
  color: rgba(0, 0, 0, 0.6);
}
header .collapsible-menu .single-dropdown a.menu-link:hover {
  color: rgba(0, 0, 0, 0.3);
}
header .collapsible-menu .single-dropdown .accordion > .accordion-item {
  border: 0px !important;
}
header .collapsible-menu .single-dropdown .accordion-item .accordion-item a.menu-link {
  padding-left: 15px;
}
header .collapsible-menu .footer-holder .social-icon li a:hover {
  transform: translateY(0px);
}
header .collapsible-menu.light .menu-list .menu-list-item a {
  color: rgba(255, 255, 255, 0.6);
}
header .collapsible-menu.light .menu-list .menu-list-item.active a {
  color: rgba(255, 255, 255, 0.3);
}
header .collapsible-menu.light .accordion-item .accordion-header .accordion-button {
  color: #fff;
}
header .collapsible-menu.light .accordion-item .accordion-header .accordion-button .icon::after, header .collapsible-menu.light .accordion-item .accordion-header .accordion-button .icon::before {
  background-color: #fff;
}
header .collapsible-menu.light .accordion-item.active > .accordion-header .accordion-button, header .collapsible-menu.light .accordion-item:hover > .accordion-header .accordion-button {
  color: rgba(255, 255, 255, 0.5);
}
header .collapsible-menu.light .single-dropdown .menu-list-item.active a.menu-link {
  color: rgba(255, 255, 255, 0.3);
}
header .collapsible-menu.light .single-dropdown a.menu-link {
  color: rgba(255, 255, 255, 0.6);
}
header.always-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}
header.always-fixed.sticky-header {
  transform: translateY(0);
}
header.reverse-scroll {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 15;
  transition: var(--default-transition);
}
header.reverse-scroll.sticky-header {
  transform: translateY(-100%);
  box-shadow: none;
}
header.reverse-scroll.sticky-header.header-appear {
  background-color: #fff;
  transform: translateY(0);
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
}
header.reverse-scroll.sticky-header.header-appear .alt-logo {
  visibility: visible;
  opacity: 1;
  width: auto;
}
header.reverse-scroll.sticky-header.header-appear .default-logo {
  opacity: 0;
  visibility: hidden;
  width: 0;
}
header.reverse-scroll.sticky-header.header-appear .menu-light .header-search-iconbar > a,
header.reverse-scroll.sticky-header.header-appear .menu-light .header-language > a,
header.reverse-scroll.sticky-header.header-appear .menu-light .header-cart-icon > a,
header.reverse-scroll.sticky-header.header-appear .menu-light .nav-bar-contact > a {
  color: #232323;
}
header.reverse-scroll.sticky-header.header-appear .menu-light .header-search-iconbar > a:hover,
header.reverse-scroll.sticky-header.header-appear .menu-light .header-language > a:hover,
header.reverse-scroll.sticky-header.header-appear .menu-light .header-cart-icon > a:hover,
header.reverse-scroll.sticky-header.header-appear .menu-light .nav-bar-contact > a:hover {
  color: rgba(35, 35, 35, 0.6);
}
header.reverse-scroll.sticky-header.header-appear .menu-light .social-icon.light a {
  color: #232323;
}
header.reverse-scroll.sticky-header.header-appear .menu-light .social-icon.light a:hover {
  color: rgba(35, 35, 35, 0.6);
}
header.reverse-scroll.sticky-header.header-appear .menu-light.bg-dark .header-search-iconbar > a,
header.reverse-scroll.sticky-header.header-appear .menu-light.bg-dark .header-language > a,
header.reverse-scroll.sticky-header.header-appear .menu-light.bg-dark .header-cart-icon > a, header.reverse-scroll.sticky-header.header-appear .menu-light.bg-black .header-search-iconbar > a,
header.reverse-scroll.sticky-header.header-appear .menu-light.bg-black .header-language > a,
header.reverse-scroll.sticky-header.header-appear .menu-light.bg-black .header-cart-icon > a {
  color: #fff;
}
header.reverse-scroll.sticky-header.header-appear .menu-light.bg-dark .header-search-iconbar > a:hover,
header.reverse-scroll.sticky-header.header-appear .menu-light.bg-dark .header-language > a:hover,
header.reverse-scroll.sticky-header.header-appear .menu-light.bg-dark .header-cart-icon > a:hover, header.reverse-scroll.sticky-header.header-appear .menu-light.bg-black .header-search-iconbar > a:hover,
header.reverse-scroll.sticky-header.header-appear .menu-light.bg-black .header-language > a:hover,
header.reverse-scroll.sticky-header.header-appear .menu-light.bg-black .header-cart-icon > a:hover {
  color: rgba(255, 255, 255, 0.6);
}
header.reverse-scroll.sticky-header.header-appear .menu-dark {
  background-color: #fff;
}
header.reverse-scroll.sticky-header.header-appear .menu-dark:not(.bg-light) .navbar-brand img {
  filter: brightness(0) invert(1);
}
header.reverse-scroll.sticky-header.header-appear > .header-transparent .navbar-nav > .nav-item > .nav-link {
  color: #232323;
}
header.reverse-scroll.sticky-header.header-appear > .header-transparent .header-push-button .push-button span {
  background-color: #fff;
}
header.reverse-scroll.sticky-header.header-appear .top-bar {
  margin-top: calc(-1px - var(--topbar-height));
}
header.responsive-sticky {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 15;
}
header.responsive-sticky .header-search-iconbar i,
header.responsive-sticky .header-language i,
header.responsive-sticky .header-cart-icon i {
  padding: 30px 0;
  transition: var(--default-transition);
}
header.responsive-sticky > .navbar-expand-lg, header.responsive-sticky > header, header.responsive-sticky > .navbar-expand-md {
  transition: var(--default-transition);
}
@media (max-width: var(--md)) {
  header.responsive-sticky > .navbar-expand-lg, header.responsive-sticky > header, header.responsive-sticky > .navbar-expand-md {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
header.responsive-sticky.sticky-header .navbar-nav > .nav-item > .nav-link {
  padding: 18px 0;
}
header.responsive-sticky.sticky-header .header-search-iconbar i,
header.responsive-sticky.sticky-header .header-language i,
header.responsive-sticky.sticky-header .header-cart-icon i {
  padding: 18px 0;
}
@media (max-width: var(--md)) {
  header.responsive-sticky.sticky-header > .navbar-expand-lg, header.responsive-sticky.sticky-header > header, header.responsive-sticky.sticky-header > .navbar-expand-md {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  header.responsive-sticky.sticky-header > .navbar-expand-lg > .nav-item > .nav-link, header.responsive-sticky.sticky-header > header > .nav-item > .nav-link, header.responsive-sticky.sticky-header > .navbar-expand-md > .nav-item > .nav-link {
    padding: 15px 0;
  }
}
header.pos-left {
  left: 0;
  top: 0;
  position: fixed;
}
@media (max-width: 991px) {
  header {
    foo: bar;
  }
  header .navbar-expand-lg.header-transparent, header header.header-transparent, header .header-transparent.navbar-expand-md {
    background-color: #fff !important;
  }
  header .navbar-expand-lg .navbar-brand .default-logo, header header .navbar-brand .default-logo, header .navbar-expand-md .navbar-brand .default-logo,
  header .navbar-expand-lg .navbar-brand .alt-logo,
  header header .navbar-brand .alt-logo,
  header .navbar-expand-md .navbar-brand .alt-logo {
    opacity: 0 !important;
    visibility: hidden !important;
    width: 0 !important;
  }
  header .navbar-expand-lg .navbar-brand .mobile-logo, header header .navbar-brand .mobile-logo, header .navbar-expand-md .navbar-brand .mobile-logo {
    opacity: 1;
    visibility: visible;
    width: auto;
  }
  header .navbar-expand-lg.navbar-dark .header-search-iconbar > a, header header.navbar-dark .header-search-iconbar > a, header .navbar-dark.navbar-expand-md .header-search-iconbar > a,
  header .navbar-expand-lg.navbar-dark .header-search-iconbar span,
  header header.navbar-dark .header-search-iconbar span,
  header .navbar-dark.navbar-expand-md .header-search-iconbar span,
  header .navbar-expand-lg.navbar-dark .header-language > a,
  header header.navbar-dark .header-language > a,
  header .navbar-dark.navbar-expand-md .header-language > a,
  header .navbar-expand-lg.navbar-dark .header-language span,
  header header.navbar-dark .header-language span,
  header .navbar-dark.navbar-expand-md .header-language span,
  header .navbar-expand-lg.navbar-dark .header-cart-icon > a,
  header header.navbar-dark .header-cart-icon > a,
  header .navbar-dark.navbar-expand-md .header-cart-icon > a,
  header .navbar-expand-lg.navbar-dark .header-cart-icon span,
  header header.navbar-dark .header-cart-icon span,
  header .navbar-dark.navbar-expand-md .header-cart-icon span {
    color: #232323;
  }
  header .navbar-expand-lg.navbar-dark.header-transparent .navbar-toggler .navbar-toggler-line, header header.navbar-dark.header-transparent .navbar-toggler .navbar-toggler-line, header .navbar-dark.header-transparent.navbar-expand-md .navbar-toggler .navbar-toggler-line {
    background-color: #232323;
  }
  header .navbar-expand-lg.navbar-dark.header-transparent .social-icon.light a, header header.navbar-dark.header-transparent .social-icon.light a, header .navbar-dark.header-transparent.navbar-expand-md .social-icon.light a {
    color: #232323;
  }
  header .navbar-expand-lg.navbar-dark.bg-dark .header-search-iconbar > a, header header.navbar-dark.bg-dark .header-search-iconbar > a, header .navbar-dark.bg-dark.navbar-expand-md .header-search-iconbar > a,
  header .navbar-expand-lg.navbar-dark.bg-dark .header-language > a,
  header header.navbar-dark.bg-dark .header-language > a,
  header .navbar-dark.bg-dark.navbar-expand-md .header-language > a,
  header .navbar-expand-lg.navbar-dark.bg-dark .header-cart-icon > a,
  header header.navbar-dark.bg-dark .header-cart-icon > a,
  header .navbar-dark.bg-dark.navbar-expand-md .header-cart-icon > a, header .navbar-expand-lg.navbar-dark.bg-black .header-search-iconbar > a, header header.navbar-dark.bg-black .header-search-iconbar > a, header .navbar-dark.bg-black.navbar-expand-md .header-search-iconbar > a,
  header .navbar-expand-lg.navbar-dark.bg-black .header-language > a,
  header header.navbar-dark.bg-black .header-language > a,
  header .navbar-dark.bg-black.navbar-expand-md .header-language > a,
  header .navbar-expand-lg.navbar-dark.bg-black .header-cart-icon > a,
  header header.navbar-dark.bg-black .header-cart-icon > a,
  header .navbar-dark.bg-black.navbar-expand-md .header-cart-icon > a {
    color: #fff;
  }
  header .navbar-expand-lg.navbar-dark.bg-dark .navbar-toggler .navbar-toggler-line, header header.navbar-dark.bg-dark .navbar-toggler .navbar-toggler-line, header .navbar-dark.bg-dark.navbar-expand-md .navbar-toggler .navbar-toggler-line, header .navbar-expand-lg.navbar-dark.bg-black .navbar-toggler .navbar-toggler-line, header header.navbar-dark.bg-black .navbar-toggler .navbar-toggler-line, header .navbar-dark.bg-black.navbar-expand-md .navbar-toggler .navbar-toggler-line {
    background-color: #fff;
  }
  header .navbar-expand-lg.menu-dark .navbar-collapse, header header.menu-dark .navbar-collapse, header .menu-dark.navbar-expand-md .navbar-collapse {
    background-color: #fff;
  }
  header .navbar-expand-lg.menu-dark .navbar-nav > .nav-item > .nav-link, header header.menu-dark .navbar-nav > .nav-item > .nav-link, header .menu-dark.navbar-expand-md .navbar-nav > .nav-item > .nav-link {
    color: #fff;
  }
  header .navbar-expand-lg .navbar-collapse, header header .navbar-collapse, header .navbar-expand-md .navbar-collapse {
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 20px 15px 0 rgba(23, 23, 23, 0.05);
    max-height: calc(100vh - 65px);
  }
  @media (max-width: var(--sm)) {
    header .navbar-expand-lg .navbar-collapse, header header .navbar-collapse, header .navbar-expand-md .navbar-collapse {
      padding: 0;
    }
  }
  header .navbar-expand-lg .navbar-collapse.show, header header .navbar-collapse.show, header .navbar-expand-md .navbar-collapse.show {
    overflow-y: auto;
  }
  header .navbar-expand-lg .navbar-collapse.show.mobile-menu-full, header header .navbar-collapse.show.mobile-menu-full, header .navbar-expand-md .navbar-collapse.show.mobile-menu-full {
    transform: translateY(0);
  }
  header .navbar-expand-lg .navbar-collapse.show.mobile-menu-full .navbar-nav > .nav-item > .nav-link, header header .navbar-collapse.show.mobile-menu-full .navbar-nav > .nav-item > .nav-link, header .navbar-expand-md .navbar-collapse.show.mobile-menu-full .navbar-nav > .nav-item > .nav-link {
    padding-top: 6px;
    padding-bottom: 6px;
  }
  header .navbar-expand-lg .navbar-collapse.show.mobile-menu-full .navbar-nav .nav-item:last-child, header header .navbar-collapse.show.mobile-menu-full .navbar-nav .nav-item:last-child, header .navbar-expand-md .navbar-collapse.show.mobile-menu-full .navbar-nav .nav-item:last-child {
    border-bottom: 0px;
  }
  header .navbar-expand-lg .navbar-collapse.show.mobile-menu-modern, header header .navbar-collapse.show.mobile-menu-modern, header .navbar-expand-md .navbar-collapse.show.mobile-menu-modern {
    padding-top: 94px;
    padding-bottom: 75px;
    transform: translateX(0);
    padding-left: 12vw;
    padding-right: 12vw;
  }
  @media (max-width: var(--xs)) {
    header .navbar-expand-lg .navbar-collapse.show.mobile-menu-modern, header header .navbar-collapse.show.mobile-menu-modern, header .navbar-expand-md .navbar-collapse.show.mobile-menu-modern {
      padding-left: 10vw;
      padding-right: 10vw;
    }
  }
  header .navbar-expand-lg .navbar-collapse:not(.show).mobile-menu-modern, header header .navbar-collapse:not(.show).mobile-menu-modern, header .navbar-expand-md .navbar-collapse:not(.show).mobile-menu-modern {
    transition-delay: 0.1s;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full, header header .navbar-collapse.mobile-menu-full, header .navbar-expand-md .navbar-collapse.mobile-menu-full {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 100px 70px;
    height: 100vh;
    max-height: 100vh;
    background-image: linear-gradient(to right top, #0039e3, #4132e0, #5e28dd, #741bd9, #8600d4);
    z-index: 1;
    display: block !important;
    transform: translateY(-100%);
    transition: var(--default-transition);
  }
  @media (max-width: var(--sm)) {
    header .navbar-expand-lg .navbar-collapse.mobile-menu-full, header header .navbar-collapse.mobile-menu-full, header .navbar-expand-md .navbar-collapse.mobile-menu-full {
      padding: 70px;
    }
  }
  @media (max-width: var(--xs)) {
    header .navbar-expand-lg .navbar-collapse.mobile-menu-full, header header .navbar-collapse.mobile-menu-full, header .navbar-expand-md .navbar-collapse.mobile-menu-full {
      padding: 50px;
      padding-bottom: 70px;
      padding-right: 35px;
    }
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .dropdown > .simple-dropdown-menu > .simple-dropdown > .nav-link, header header .navbar-collapse.mobile-menu-full .dropdown > .simple-dropdown-menu > .simple-dropdown > .nav-link, header .navbar-expand-md .navbar-collapse.mobile-menu-full .dropdown > .simple-dropdown-menu > .simple-dropdown > .nav-link {
    color: white !important;
    opacity: 0.7 !important;
    font-size: 14px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .navbar-nav, header header .navbar-collapse.mobile-menu-full .navbar-nav, header .navbar-expand-md .navbar-collapse.mobile-menu-full .navbar-nav {
    display: block;
    overflow: auto;
    height: 100%;
    padding-left: 25px;
    padding-right: 25px;
  }
  @media (max-width: var(--xs)) {
    header .navbar-expand-lg .navbar-collapse.mobile-menu-full .navbar-nav, header header .navbar-collapse.mobile-menu-full .navbar-nav, header .navbar-expand-md .navbar-collapse.mobile-menu-full .navbar-nav {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .navbar-nav .nav-item, header header .navbar-collapse.mobile-menu-full .navbar-nav .nav-item, header .navbar-expand-md .navbar-collapse.mobile-menu-full .navbar-nav .nav-item {
    padding-top: 10px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    text-align: left;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .navbar-nav .nav-item .nav-link, header header .navbar-collapse.mobile-menu-full .navbar-nav .nav-item .nav-link, header .navbar-expand-md .navbar-collapse.mobile-menu-full .navbar-nav .nav-item .nav-link {
    color: white !important;
    font-size: 17px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .navbar-nav .nav-item .nav-link.active, header header .navbar-collapse.mobile-menu-full .navbar-nav .nav-item .nav-link.active, header .navbar-expand-md .navbar-collapse.mobile-menu-full .navbar-nav .nav-item .nav-link.active {
    color: rgba(255, 255, 255, 0.6) !important;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .navbar-nav .nav-item i, header header .navbar-collapse.mobile-menu-full .navbar-nav .nav-item i, header .navbar-expand-md .navbar-collapse.mobile-menu-full .navbar-nav .nav-item i {
    font-size: 17px;
    color: white !important;
    top: 7px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .navbar-toggler, header header .navbar-collapse.mobile-menu-full .navbar-toggler, header .navbar-expand-md .navbar-collapse.mobile-menu-full .navbar-toggler {
    position: absolute;
    top: 30px;
    right: 30px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .megamenu, header header .navbar-collapse.mobile-menu-full .megamenu, header .navbar-expand-md .navbar-collapse.mobile-menu-full .megamenu {
    background-color: transparent;
    left: 0 !important;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .megamenu .title, header header .navbar-collapse.mobile-menu-full .megamenu .title, header .navbar-expand-md .navbar-collapse.mobile-menu-full .megamenu .title {
    opacity: 0.7;
    padding-bottom: 12px;
    margin-bottom: 4px;
    color: #fff;
    font-size: 12px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .megamenu .nav-item, header header .navbar-collapse.mobile-menu-full .megamenu .nav-item, header .navbar-expand-md .navbar-collapse.mobile-menu-full .megamenu .nav-item {
    padding-bottom: 12px;
    padding-top: 0;
    border-bottom: 0;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .megamenu .nav-item .nav-link, header header .navbar-collapse.mobile-menu-full .megamenu .nav-item .nav-link, header .navbar-expand-md .navbar-collapse.mobile-menu-full .megamenu .nav-item .nav-link {
    font-size: 13px;
    line-height: normal;
    margin-bottom: 5px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .simple-dropdown-menu, header header .navbar-collapse.mobile-menu-full .simple-dropdown-menu, header .navbar-expand-md .navbar-collapse.mobile-menu-full .simple-dropdown-menu {
    background-color: transparent;
    left: 0 !important;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown > .nav-link, header header .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown > .nav-link, header .navbar-expand-md .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown > .nav-link {
    color: #ffffff;
    padding-bottom: 12px;
    font-size: 15px;
    margin-bottom: 4px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown, header header .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown, header .navbar-expand-md .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown {
    border-bottom: 0;
    padding-bottom: 12px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown > .nav-link, header header .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown > .nav-link, header .navbar-expand-md .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown > .nav-link {
    font-size: 13px;
    line-height: normal;
    margin: 0;
    padding: 0;
    color: white;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown > .nav-link.active, header header .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown > .nav-link.active, header .navbar-expand-md .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown > .nav-link.active {
    color: rgba(255, 255, 255, 0.6) !important;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown .simple-dropdown-menu, header header .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown .simple-dropdown-menu, header .navbar-expand-md .navbar-collapse.mobile-menu-full .simple-dropdown-menu .simple-dropdown .simple-dropdown-menu {
    margin-top: 15px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern, header header .navbar-collapse.mobile-menu-modern, header .navbar-expand-md .navbar-collapse.mobile-menu-modern {
    display: block;
    padding-top: 100px;
    padding-bottom: 100px;
    padding-right: 12vw;
    padding-left: 12vW;
    position: fixed;
    top: 0;
    right: 0;
    left: auto;
    width: 70vw;
    transform: translateX(calc(70vw + 10px));
    height: 100vh;
    max-height: 100vh;
    background-image: linear-gradient(to right top, #0039e3, #4132e0, #5e28dd, #741bd9, #8600d4);
    z-index: 1;
    transition: var(--default-transition);
  }
  @media (max-width: var(--xs)) {
    header .navbar-expand-lg .navbar-collapse.mobile-menu-modern, header header .navbar-collapse.mobile-menu-modern, header .navbar-expand-md .navbar-collapse.mobile-menu-modern {
      transform: translateX(70vw);
      width: 85vw;
      padding-right: 10vw;
      padding-left: 10vW;
      padding-top: 30px;
      padding-bottom: 30px;
      transform: translateX(calc(85vw + 10px));
    }
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .dropdown > .simple-dropdown-menu > .simple-dropdown, header header .navbar-collapse.mobile-menu-modern .dropdown > .simple-dropdown-menu > .simple-dropdown, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .dropdown > .simple-dropdown-menu > .simple-dropdown {
    margin-bottom: 25px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .dropdown > .simple-dropdown-menu > .simple-dropdown:last-child, header header .navbar-collapse.mobile-menu-modern .dropdown > .simple-dropdown-menu > .simple-dropdown:last-child, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .dropdown > .simple-dropdown-menu > .simple-dropdown:last-child {
    margin-bottom: 0;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .dropdown > .simple-dropdown-menu > .simple-dropdown > .nav-link, header header .navbar-collapse.mobile-menu-modern .dropdown > .simple-dropdown-menu > .simple-dropdown > .nav-link, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .dropdown > .simple-dropdown-menu > .simple-dropdown > .nav-link {
    font-size: 14px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .navbar-nav, header header .navbar-collapse.mobile-menu-modern .navbar-nav, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .navbar-nav {
    display: block;
    overflow: auto;
    height: 100%;
    padding: 0;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item, header header .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item {
    padding-top: 10px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item:last-child, header header .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item:last-child, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item:last-child {
    border-bottom: 0;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item .nav-link, header header .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item .nav-link, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item .nav-link {
    color: white !important;
    font-size: 17px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item i, header header .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item i, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .navbar-nav .nav-item i {
    color: white;
    top: 10px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .navbar-toggler, header header .navbar-collapse.mobile-menu-modern .navbar-toggler, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .navbar-toggler {
    position: absolute;
    top: 30px;
    right: 30px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .megamenu, header header .navbar-collapse.mobile-menu-modern .megamenu, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .megamenu {
    background-color: transparent;
    left: 0 !important;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .megamenu .title, header header .navbar-collapse.mobile-menu-modern .megamenu .title, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .megamenu .title {
    color: #ffffff;
    opacity: 0.7;
    font-size: 15px;
    margin-bottom: 15px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .megamenu .nav-item, header header .navbar-collapse.mobile-menu-modern .megamenu .nav-item, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .megamenu .nav-item {
    padding-top: 0;
    padding-bottom: 10px;
    border-bottom: 0;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .megamenu .nav-item .nav-link, header header .navbar-collapse.mobile-menu-modern .megamenu .nav-item .nav-link, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .megamenu .nav-item .nav-link {
    font-size: 13px;
    line-height: normal;
    margin-bottom: 5px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .megamenu .nav-item .nav-link.active, header header .navbar-collapse.mobile-menu-modern .megamenu .nav-item .nav-link.active, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .megamenu .nav-item .nav-link.active {
    color: rgba(255, 255, 255, 0.6) !important;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .simple-dropdown-menu, header header .navbar-collapse.mobile-menu-modern .simple-dropdown-menu, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .simple-dropdown-menu {
    background: transparent;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown, header header .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown {
    border-bottom: 0;
    margin-bottom: 10px;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown:last-child, header header .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown:last-child, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown:last-child {
    margin-bottom: 0;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown > .nav-link, header header .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown > .nav-link, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown > .nav-link {
    font-size: 13px;
    line-height: normal;
    margin: 0;
    padding: 0;
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown > .nav-link.active, header header .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown > .nav-link.active, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown > .nav-link.active {
    text-decoration: underline;
    color: rgba(255, 255, 255, 0.7);
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown > span.nav-link, header header .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown > span.nav-link, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown > span.nav-link {
    color: rgba(255, 255, 255, 0.7);
  }
  header .navbar-expand-lg .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown .simple-dropdown-menu, header header .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown .simple-dropdown-menu, header .navbar-expand-md .navbar-collapse.mobile-menu-modern .simple-dropdown-menu .simple-dropdown .simple-dropdown-menu {
    margin-top: 10px;
    margin-bottom: 25px;
  }
  header .navbar-expand-lg .nav-item .simple-dropdown-menu, header header .nav-item .simple-dropdown-menu, header .navbar-expand-md .nav-item .simple-dropdown-menu,
  header .navbar-expand-lg .nav-item .megamenu,
  header header .nav-item .megamenu,
  header .navbar-expand-md .nav-item .megamenu {
    display: none;
    position: relative;
    width: 100%;
    box-shadow: none;
    transform: translateX(0);
    left: 0;
    padding: 0 0 20px 15px;
  }
  header .navbar-expand-lg .nav-item .simple-dropdown-menu li, header header .nav-item .simple-dropdown-menu li, header .navbar-expand-md .nav-item .simple-dropdown-menu li,
  header .navbar-expand-lg .nav-item .megamenu li,
  header header .nav-item .megamenu li,
  header .navbar-expand-md .nav-item .megamenu li {
    padding: 0;
  }
  header .navbar-expand-lg .nav-item .simple-dropdown-menu li > .simple-dropdown-menu, header header .nav-item .simple-dropdown-menu li > .simple-dropdown-menu, header .navbar-expand-md .nav-item .simple-dropdown-menu li > .simple-dropdown-menu,
  header .navbar-expand-lg .nav-item .simple-dropdown-menu li > .megamenu,
  header header .nav-item .simple-dropdown-menu li > .megamenu,
  header .navbar-expand-md .nav-item .simple-dropdown-menu li > .megamenu,
  header .navbar-expand-lg .nav-item .megamenu li > .simple-dropdown-menu,
  header header .nav-item .megamenu li > .simple-dropdown-menu,
  header .navbar-expand-md .nav-item .megamenu li > .simple-dropdown-menu,
  header .navbar-expand-lg .nav-item .megamenu li > .megamenu,
  header header .nav-item .megamenu li > .megamenu,
  header .navbar-expand-md .nav-item .megamenu li > .megamenu {
    left: 0;
    padding: 0;
  }
  header .navbar-expand-lg .nav-item .simple-dropdown-menu li > span, header header .nav-item .simple-dropdown-menu li > span, header .navbar-expand-md .nav-item .simple-dropdown-menu li > span,
  header .navbar-expand-lg .nav-item .megamenu li > span,
  header header .nav-item .megamenu li > span,
  header .navbar-expand-md .nav-item .megamenu li > span {
    color: #232323;
  }
  header .navbar-expand-lg .nav-item .simple-dropdown-menu li > span i, header header .nav-item .simple-dropdown-menu li > span i, header .navbar-expand-md .nav-item .simple-dropdown-menu li > span i,
  header .navbar-expand-lg .nav-item .megamenu li > span i,
  header header .nav-item .megamenu li > span i,
  header .navbar-expand-md .nav-item .megamenu li > span i {
    display: none;
  }
  header .navbar-expand-lg .nav-item .simple-dropdown-menu .nav-link, header header .nav-item .simple-dropdown-menu .nav-link, header .navbar-expand-md .nav-item .simple-dropdown-menu .nav-link,
  header .navbar-expand-lg .nav-item .megamenu .nav-link,
  header header .nav-item .megamenu .nav-link,
  header .navbar-expand-md .nav-item .megamenu .nav-link {
    padding: 3px 15px 3px;
    font-size: 14px;
    margin-bottom: 5px;
  }
  header .navbar-expand-lg .nav-item .megamenu > div, header header .nav-item .megamenu > div, header .navbar-expand-md .nav-item .megamenu > div {
    display: block;
  }
  header .navbar-expand-lg .nav-item .megamenu ul, header header .nav-item .megamenu ul, header .navbar-expand-md .nav-item .megamenu ul {
    display: block;
    padding-right: 0;
    margin-bottom: 20px;
  }
  @media (max-width: var(--md)) {
    header .navbar-expand-lg .nav-item .megamenu ul.img-wrapper, header header .nav-item .megamenu ul.img-wrapper, header .navbar-expand-md .nav-item .megamenu ul.img-wrapper {
      display: none;
    }
  }
  @media (max-width: var(--sm)) {
    header .navbar-expand-lg .nav-item .megamenu ul.img-wrapper, header header .nav-item .megamenu ul.img-wrapper, header .navbar-expand-md .nav-item .megamenu ul.img-wrapper {
      display: none;
    }
  }
  @media (max-width: var(--xs)) {
    header .navbar-expand-lg .nav-item .megamenu ul.img-wrapper, header header .nav-item .megamenu ul.img-wrapper, header .navbar-expand-md .nav-item .megamenu ul.img-wrapper {
      display: none;
    }
  }
  header .navbar-expand-lg .nav-item .megamenu ul:last-child, header header .nav-item .megamenu ul:last-child, header .navbar-expand-md .nav-item .megamenu ul:last-child {
    margin-bottom: 0;
  }
  header .navbar-expand-lg .nav-item .megamenu ul .nav-link, header header .nav-item .megamenu ul .nav-link, header .navbar-expand-md .nav-item .megamenu ul .nav-link {
    margin-bottom: 0;
    padding: 0;
  }
  header .navbar-expand-lg .nav-item > .simple-dropdown-menu, header header .nav-item > .simple-dropdown-menu, header .navbar-expand-md .nav-item > .simple-dropdown-menu,
  header .navbar-expand-lg .nav-item > .megamenu,
  header header .nav-item > .megamenu,
  header .navbar-expand-md .nav-item > .megamenu {
    margin-top: 10px;
  }
  header .navbar-expand-lg .nav-item > .simple-dropdown-menu > .simple-dropdown, header header .nav-item > .simple-dropdown-menu > .simple-dropdown, header .navbar-expand-md .nav-item > .simple-dropdown-menu > .simple-dropdown,
  header .navbar-expand-lg .nav-item > .megamenu > .simple-dropdown,
  header header .nav-item > .megamenu > .simple-dropdown,
  header .navbar-expand-md .nav-item > .megamenu > .simple-dropdown {
    margin-bottom: 10px;
  }
  header .navbar-expand-lg .nav-item > .simple-dropdown-menu > .simple-dropdown > a, header header .nav-item > .simple-dropdown-menu > .simple-dropdown > a, header .navbar-expand-md .nav-item > .simple-dropdown-menu > .simple-dropdown > a,
  header .navbar-expand-lg .nav-item > .megamenu > .simple-dropdown > a,
  header header .nav-item > .megamenu > .simple-dropdown > a,
  header .navbar-expand-md .nav-item > .megamenu > .simple-dropdown > a {
    color: #232323;
  }
  header .navbar-expand-lg .navbar-nav, header header .navbar-nav, header .navbar-expand-md .navbar-nav {
    padding: 15px 30px 25px;
  }
  @media (max-width: 767px) {
    header .navbar-expand-lg .navbar-nav, header header .navbar-nav, header .navbar-expand-md .navbar-nav {
      padding: 15px 15px 25px;
    }
  }
  header .navbar-expand-lg .navbar-nav > .nav-item > .nav-link, header header .navbar-nav > .nav-item > .nav-link, header .navbar-expand-md .navbar-nav > .nav-item > .nav-link {
    padding-top: 9px;
    padding-bottom: 9px;
    font-size: 15px;
    line-height: 30px;
    color: #232323;
    margin: 0;
  }
  header .navbar-expand-lg .navbar-nav > .nav-item.dropdown .nav-link, header header .navbar-nav > .nav-item.dropdown .nav-link, header .navbar-expand-md .navbar-nav > .nav-item.dropdown .nav-link {
    position: relative;
  }
  header .navbar-expand-lg .navbar-nav > .nav-item.dropdown > i, header header .navbar-nav > .nav-item.dropdown > i, header .navbar-expand-md .navbar-nav > .nav-item.dropdown > i {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    justify-content: flex-end;
    align-items: center;
    text-align: right;
    width: 48px;
    height: 48px;
    font-weight: 900;
    line-height: 1;
  }
  header .navbar-expand-lg .navbar-nav > .nav-item.dropdown.open .simple-dropdown-menu, header header .navbar-nav > .nav-item.dropdown.open .simple-dropdown-menu, header .navbar-expand-md .navbar-nav > .nav-item.dropdown.open .simple-dropdown-menu,
  header .navbar-expand-lg .navbar-nav > .nav-item.dropdown.open .megamenu,
  header header .navbar-nav > .nav-item.dropdown.open .megamenu,
  header .navbar-expand-md .navbar-nav > .nav-item.dropdown.open .megamenu {
    display: block;
    opacity: 1;
    visibility: visible;
    left: 0 !important;
    top: 0 !important;
    transform: translateY(0) !important;
  }
}
@media (max-width: 767px) {
  header {
    foo: bar;
  }
}
@media (max-width: 575px) {
  header {
    foo: bar;
  }
}

.left-menu-modern-sidebar .left-menu-wrapper {
  transform: translateX(-120%);
}
.left-menu-modern-sidebar .left-menu-wrapper.show {
  transform: translateX(0);
}

.header-with-topbar.sticky-header.header-appear.reverse-scroll {
  transform: translateY(0);
}
.header-with-topbar .dropdown > button::after {
  display: none;
}
.header-with-topbar .dropdown > button:hover {
  border-color: inherit;
  color: inherit;
}
.header-with-topbar .show > .btn-success.dropdown-toggle:focus {
  box-shadow: none;
}
.header-with-topbar .show > .btn-primary.dropdown-toggle {
  color: #828282;
}
.header-with-topbar .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: none;
}
.header-with-topbar .dropdown-menu {
  left: auto;
  background-color: #ffffff;
  border-radius: 6px;
  border-style: none;
  text-align: left;
  padding: 15px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
}
.header-with-topbar .dropdown-items:hover {
  background-color: transparent;
}

.header-push-button {
  vertical-align: middle;
  padding: 0;
}
.header-push-button.dark .splitportfolio-header li:hover a {
  color: rgba(0, 0, 0, 0.6);
}
.header-push-button.dark .splitportfolio-header li a {
  color: #232323;
}
.header-push-button.dark .splitportfolio-header li a::before {
  background-color: rgba(0, 0, 0, 0.6);
}
.header-push-button.dark .close-btn {
  color: #000;
}
.header-push-button .close-btn {
  position: absolute;
  font-size: 16px;
  color: #fff;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  top: 20px;
  right: 20px;
}
@media (max-width: var(--xs)) {
  .header-push-button .close-btn {
    top: 0;
    right: 0;
  }
}
.header-push-button .push-button {
  position: relative;
  width: 22px;
  height: 14px;
  display: block;
  top: 1px;
}
.header-push-button .hamburger-menu-wrapper {
  position: fixed;
  top: 0;
  right: -110%;
  height: 100vh;
  transition: var(--default-transition);
}
.header-push-button .hamburger-menu-wrapper.show {
  right: 0;
}
.header-push-button .hamburger-menu-wrapper.pos-left {
  right: auto;
  left: -110%;
}
.header-push-button .hamburger-menu-wrapper.pos-left.show {
  left: 0;
}

/* Hamburger Menu Button*/
.navbar-expand .navbar-toggler {
  display: block;
}

.navbar-toggler {
  display: inline-block;
  position: relative;
  padding: 0;
  vertical-align: middle;
  border-radius: 0;
  font-size: 24px;
  width: 22px;
  height: 14px;
  border: none;
}
.navbar-toggler:focus {
  box-shadow: none;
}
.navbar-toggler .navbar-toggler-line {
  display: block;
  position: absolute;
  right: 0;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0;
  background-color: #232323;
  transform: rotate(0);
  content: "";
  height: 2px;
  width: 22px;
  transition: 0.25s ease-in-out;
}
.navbar-toggler .navbar-toggler-line:nth-child(1) {
  top: 0;
  width: 14px;
}
.navbar-toggler .navbar-toggler-line:nth-child(2), .navbar-toggler .navbar-toggler-line:nth-child(3) {
  top: 6px;
}
.navbar-toggler .navbar-toggler-line:nth-child(4) {
  top: 12px;
  width: 14px;
}
.navbar-toggler:not(.collapsed) .navbar-toggler-line:nth-child(1) {
  top: 7px;
  width: 0%;
}
.navbar-toggler:not(.collapsed) .navbar-toggler-line:nth-child(2) {
  transform: rotate(45deg);
}
.navbar-toggler:not(.collapsed) .navbar-toggler-line:nth-child(3) {
  transform: rotate(-45deg);
}
.navbar-toggler:not(.collapsed) .navbar-toggler-line:nth-child(4) {
  top: 7px;
  width: 0%;
}

.navbar-expand .navbar-toggler {
  border-color: transparent;
}

.header-search-iconbar .form-wrapper {
  display: block;
  height: 100vh;
  left: 0;
  opacity: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  transition: all 0.2s ease-in-out;
  visibility: hidden;
  width: 100%;
  z-index: 999;
  background-color: rgba(35, 35, 35, 0.9019607843);
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), pointer;
}
.header-search-iconbar .form-wrapper.show {
  opacity: 1;
  visibility: visible;
}
.header-search-iconbar .form-wrapper.show .search-form {
  cursor: auto;
  transform: translateY(0);
}
.header-search-iconbar .form-wrapper .search-close {
  outline: 2px solid transparent;
  outline-offset: 2px;
  display: block;
  z-index: 1046;
  line-height: 44px;
  overflow: visible;
  position: fixed;
  padding: 0;
  color: #000000;
  font-weight: 300;
  border-style: none;
  cursor: pointer;
  outline: 0;
  top: 30px;
  right: 35px;
  font-size: 30px;
  width: 44px;
  height: 44px;
}
@media (max-height: var(--xs)) {
  .header-search-iconbar .form-wrapper .search-close {
    top: 5px;
    right: 5px;
  }
}
.header-search-iconbar .form-wrapper .search-form {
  transform: translateY(-100%);
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 0;
  height: 450px;
  transition: all 0.4s ease-in-out;
  cursor: auto;
}
.header-search-iconbar .form-wrapper .search-form .search-form-box {
  width: 45%;
  position: relative;
}
@media (max-height: var(--md)) {
  .header-search-iconbar .form-wrapper .search-form .search-form-box {
    width: 60%;
  }
}
@media (max-height: var(--xs)) {
  .header-search-iconbar .form-wrapper .search-form .search-form-box {
    width: 90%;
  }
}
.header-search-iconbar .form-wrapper .search-form .search-form-box .search-input {
  font-weight: 300;
  width: 100%;
  border-radius: 0;
  color: #232323;
  font-size: 20px;
  padding-top: 10px;
  padding-right: 38px;
  padding-bottom: 10px;
  padding-left: 2px;
  line-height: 40px;
}
@media (max-width: var(--xs)) {
  .header-search-iconbar .form-wrapper .search-form .search-form-box .search-input {
    line-height: 30px;
    font-size: 18px;
    padding-top: 8px;
    padding-right: 38px;
    padding-bottom: 8px;
    padding-left: 2px;
  }
}
.header-search-iconbar .form-wrapper .search-form .search-form-box input::placeholder {
  color: #232323;
}
.header-search-iconbar .form-wrapper .search-button {
  color: #232323;
  outline: 2px solid transparent;
  outline-offset: 2px;
  right: 0;
  position: absolute;
  cursor: pointer;
  font-size: 15px;
  margin-right: 0;
  z-index: 0;
  bottom: 19px;
  line-height: normal;
}
.header-search-iconbar .form-wrapper .search-button i {
  padding: 1px 6px;
}

.collapse {
  visibility: visible;
}

.menu-modern {
  margin-left: -70vw;
  padding-right: 70vw;
}
@media (max-width: var(--xs)) {
  .menu-modern {
    margin-left: -85vw;
    padding-right: 85vw;
  }
}

.mobile-menu header .smooth-scrollbar {
  overflow: visible !important;
}
@media (max-width: var(--md)) {
  .mobile-menu header .smooth-scrollbar {
    overflow: hidden !important;
  }
}
.mobile-menu header .smooth-scrollbar .scroll-content {
  padding-right: 0px;
}

.toplogo-header .navbar-nav > .nav-item > .nav-link {
  padding: 25px 0;
}`, "",{"version":3,"sources":["webpack://./src/Assets/scss/layouts/_header.scss"],"names":[],"mappings":"AACE;EACE,qCAAA;AAAJ;AAII;EACE,sBAAA;AAFN;AAOQ;EACE,wBAAA;AALV;;AAaE;EACE,qCAAA;AAVJ;AAcI;EACE,UAAA;EACA,aAAA;EACA,kBAAA;EACA,uCAAA;EACA,qCAAA;AAZN;AAcM;EACE,aAAA;EACA,mBAAA;AAZR;AAcQ;EACE,qBAAA;EACA,kBAAA;AAZV;AAkBM;EACE,UAAA;EACA,mBAAA;AAhBR;AAsBI;EACE,cAAA;EACA,eAAA;EACA,qCAAA;AApBN;AAsBM;EACE,yBAAA;AApBR;AAyBE;EACE,kBAAA;AAvBJ;AAyBI;EACE,cAAA;EACA,eAAA;EACA,qCAAA;AAvBN;AAyBM;EACE,yBAAA;AAvBR;AA4BM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,qCAAA;AA1BR;AA4BQ;EACE,cAAA;AA1BV;AA6BQ;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;AA3BV;AA+BM;EACE,UAAA;EACA,mBAAA;AA7BR;AAkCE;EACE,kBAAA;AAhCJ;AAkCI;EACE,cAAA;EACA,qCAAA;AAhCN;AAmCI;EACE,UAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,uCAAA;AAjCN;AAmCM;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,aAAA;AAjCR;AAmCQ;EACE,mBAAA;EACA,0BAAA;AAjCV;AAoCQ;EAEE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,qCAAA;AAlCV;AAoCU;EACE,cAAA;AAlCZ;AAsCQ;EACE,eAAA;EACA,UAAA;EACA,qBAAA;AApCV;AAuCQ;EACE,qBAAA;EACA,UAAA;EACA,kBAAA;AArCV;AAuCU;EAEE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AArCZ;AAwCU;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAtCZ;AA2CM;EACE,sBAAA;EACA,yBAAA;AAzCR;AA2CQ;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAzCV;AA+CM;EACE,4BAAA;EACA,eAAA;AA7CR;AAkDE;;;;EAIE,mBAAA;EACA,kBAAA;EACA,kBAAA;AAhDJ;AAmDE;EACE,kBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;AAjDJ;AAmDI;EACE,aAAA;AAjDN;AAqDM;EACE,UAAA;EACA,mBAAA;AAnDR;AAsDM;EACE,UAAA;EACA,mBAAA;AApDR;AAwDY;EACE,UAAA;EACA,mBAAA;AAtDd;AA0DkB;EACE,UAAA;EACA,mBAAA;AAxDpB;AAkEI;EACE,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AAhEN;AAkEM;EACE,uBAAA;EACA,kBAAA;EACA,cAAA;AAhER;AAkEQ;EACE,eAAA;EACA,UAAA;EACA,cAAA;AAhEV;AAkEU;EACE,QAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,qCAAA;AAhEZ;AAmEU;EACE,cAAA;AAjEZ;AAqEQ;EACE,wBAAA;EACA,MAAA;EACA,UAAA;AAnEV;AAqEU;EACE,WAAA;EACA,qBAAA;AAnEZ;AA0EU;EACE,cAAA;AAxEZ;AA8EI;EACE,cAAA;AA5EN;AA8EM;EACE,cAAA;AA5ER;AAiFE;EACE,aAAA;EACA,uBAAA;AA/EJ;AAkFM;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qCAAA;AAhFR;AAoFQ;EACE,YAAA;AAlFV;AAwFI;EACE,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,OAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AAtFN;AAwFM;EACE,mBAAA;AAtFR;AAwFQ;EACE,cAAA;AAtFV;AAyFQ;EACE,mBAAA;AAvFV;AA0FQ;EAXF;IAYI,mBAAA;EAvFR;AACF;AA2FQ;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,4BAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;AAzFV;AA2FU;EACE,cAAA;AAzFZ;AA8FU;EACE,cAAA;AA5FZ;AAiGM;EA9DF;IA+DI,uBAAA;EA9FN;AACF;AAmGM;EACE,UAAA;AAjGR;AAmGQ;EACE,cAAA;AAjGV;AAwGI;EACE,gBAAA;AAtGN;AAyGI;EACE,mBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AAvGN;AA0GI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,yBAAA;AAxGN;AA2GI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,yBAAA;AAzGN;AAuHQ;;;;;;;EACE,WAAA;AA/GV;AAiHU;;;;;;;EACE,YAAA;AAzGZ;AAmHM;;;;;;;;;;;;;;;;;;;;;EACE,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AA7FR;AA+FQ;;;;;;;;;;;;;;;;;;;;;EACE,+BAAA;AAzEV;AA+EM;;;;;;;EACE,sBAAA;AAvER;AA8EI;EACE,yBAAA;AA5EN;AA+EQ;EACE,WAAA;AA7EV;AAmFU;EACE,WAAA;AAjFZ;AAsFU;EACE,WAAA;AApFZ;AA0FI;;EAEE,yBAAA;AAxFN;AA2FQ;;EACE,qCAAA;AAxFV;AA0FU;;EACE,WAAA;AAvFZ;AA2FQ;;EACE,qCAAA;AAxFV;AA0FU;;EACE,WAAA;AAvFZ;AA8FE;EACE,4BAAA;AA5FJ;AA8FI;EACE,YAAA;EACA,6BAAA;AA5FN;AAiGU;EACE,yBAAA;AA/FZ;AAoGM;EACE,kBAAA;EACA,aAAA;AAlGR;AAsGQ;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AApGV;AAsGU;EACE,gBAAA;EACA,aAAA;AApGZ;AAyGY;;EAEE,gCAAA;AAvGd;AA2GU;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAzGZ;AA2GY;EAEE,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,qCAAA;AA1Gd;AA6GY;EACE,sBAAA;EACA,wBAAA;AA3Gd;AA+GU;EACE,gBAAA;EACA,6BAAA;AA7GZ;AAgHc;EACE,uBAAA;AA9GhB;AAiHc;EACE,6BAAA;AA/GhB;AAuHQ;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AArHV;AAuHU;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AArHZ;AAwHU;EACE,eAAA;EACA,UAAA;EAEA,iBAAA;AAtHZ;AA4HI;EACE,kBAAA;AA1HN;AA4HM;EACE,iBAAA;AA1HR;AA4HQ;EACE,yBAAA;AA1HV;AA4HU;EACE,yBAAA;AA1HZ;AA+HU;EACE,yBAAA;AA7HZ;AAqIQ;EACE,sBAAA;AAnIV;AAuIc;EACE,yBAAA;AArIhB;AA8IM;EACE,yBAAA;AA5IR;AA8IQ;EACE,yBAAA;AA5IV;AAiJQ;EACE,sBAAA;AA/IV;AAqJU;EACE,kBAAA;AAnJZ;AA6JY;EACE,0BAAA;AA3Jd;AAqKU;EACE,+BAAA;AAnKZ;AAuKY;EACE,+BAAA;AArKd;AA6KU;EACE,WAAA;AA3KZ;AA+Kc;EAEE,sBAAA;AA9KhB;AAuLY;EACE,+BAAA;AArLd;AA8LY;EACE,+BAAA;AA5Ld;AAiMQ;EACE,+BAAA;AA/LV;AAsME;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AApMJ;AAsMI;EACE,wBAAA;AApMN;AAwME;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,qCAAA;AAtMJ;AAwMI;EACE,4BAAA;EACA,gBAAA;AAtMN;AAwMM;EACE,sBAAA;EACA,wBAAA;EACA,uCAAA;AAtMR;AAwMQ;EACE,mBAAA;EACA,UAAA;EACA,WAAA;AAtMV;AAyMQ;EACE,UAAA;EACA,kBAAA;EACA,QAAA;AAvMV;AAiNY;;;;EACE,cAAA;AA5Md;AA8Mc;;;;EACE,4BAAA;AAzMhB;AA+MY;EACE,cAAA;AA7Md;AA+Mc;EACE,4BAAA;AA7MhB;AAyNc;;;;;EACE,WAAA;AAnNhB;AAqNgB;;;;;EACE,+BAAA;AA/MlB;AAsNQ;EACE,sBAAA;AApNV;AAwNc;EACE,+BAAA;AAtNhB;AA+Nc;EACE,cAAA;AA7NhB;AAoOc;EACE,sBAAA;AAlOhB;AAwOQ;EACE,6CAAA;AAtOV;AA4OE;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AA1OJ;AA+OM;;;EACE,eAAA;EACA,qCAAA;AA3OR;AA+OI;EACE,qCAAA;AA7ON;AA+OM;EAHF;IAII,iBAAA;IACA,oBAAA;EA5ON;AACF;AAkPU;EACE,eAAA;AAhPZ;AAwPQ;;;EACE,eAAA;AApPV;AAyPQ;EADF;IAEI,iBAAA;IACA,oBAAA;EAtPR;EAyPU;IACE,eAAA;EAvPZ;AACF;AA8PE;EACE,OAAA;EACA,MAAA;EACA,eAAA;AA5PJ;AA+PE;EA17BF;IAm/CI,QAAA;EApzBF;EA6PI;IACE,iCAAA;EA3PN;EAgQM;;;;IAEE,qBAAA;IACA,6BAAA;IACA,mBAAA;EA5PR;EA+PM;IACE,UAAA;IACA,mBAAA;IACA,WAAA;EA7PR;EAuQQ;;;;;;;;;;;;;;;;IAEE,cAAA;EAvPV;EA6PU;IACE,yBAAA;EA3PZ;EAiQY;IACE,cAAA;EA/Pd;EA2QU;;;;;;;;;;;;;IACE,WAAA;EA7PZ;EAkQU;IACE,sBAAA;EAhQZ;EAuQM;IACE,sBAAA;EArQR;EAwQM;IACE,WAAA;EAtQR;EA0QI;IACE,gBAAA;IACA,kBAAA;IACA,OAAA;IACA,SAAA;IACA,WAAA;IACA,sBAAA;IACA,gDAAA;IACA,8BAAA;EAxQN;EA0QM;IAVF;MAWI,UAAA;IAvQN;EACF;EAyQM;IACE,gBAAA;EAvQR;EAyQQ;IACE,wBAAA;EAvQV;EA+Qc;IACE,gBAAA;IACA,mBAAA;EA7QhB;EAoRc;IACE,kBAAA;EAlRhB;EAwRQ;IACE,iBAAA;IACA,oBAAA;IACA,wBAAA;IACA,kBAAA;IACA,mBAAA;EAtRV;EAwRU;IAPF;MAQI,kBAAA;MACA,mBAAA;IArRV;EACF;EA0RQ;IACE,sBAAA;EAxRV;EA6RM;IACE,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,mBAAA;IACA,aAAA;IACA,iBAAA;IACA,4FAAA;IAMA,UAAA;IACA,yBAAA;IACA,4BAAA;IACA,qCAAA;EAhSR;EAkSQ;IAnBF;MAoBI,aAAA;IA/RR;EACF;EAiSQ;IAvBF;MAwBI,aAAA;MACA,oBAAA;MACA,mBAAA;IA9RR;EACF;EAmSc;IACE,uBAAA;IACA,uBAAA;IACA,eAAA;EAjShB;EAuSQ;IACE,cAAA;IACA,cAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;EArSV;EAuSU;IAPF;MAQI,iBAAA;MACA,kBAAA;IApSV;EACF;EAsSU;IACE,iBAAA;IACA,oBAAA;IACA,iDAAA;IACA,gBAAA;EApSZ;EAsSY;IACE,uBAAA;IACA,eAAA;EApSd;EAsSc;IACE,0CAAA;EApShB;EAwSY;IACE,eAAA;IACA,uBAAA;IACA,QAAA;EAtSd;EA2SQ;IACE,kBAAA;IACA,SAAA;IACA,WAAA;EAzSV;EA4SQ;IACE,6BAAA;IACA,kBAAA;EA1SV;EA4SU;IACE,YAAA;IACA,oBAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;EA1SZ;EA6SU;IACE,oBAAA;IACA,cAAA;IACA,gBAAA;EA3SZ;EA6SY;IACE,eAAA;IACA,mBAAA;IACA,kBAAA;EA3Sd;EAgTQ;IACE,6BAAA;IACA,kBAAA;EA9SV;EAgTU;IACE,cAAA;IACA,oBAAA;IACA,eAAA;IACA,kBAAA;EA9SZ;EAiTU;IACE,gBAAA;IACA,oBAAA;EA/SZ;EAiTY;IACE,eAAA;IACA,mBAAA;IACA,SAAA;IACA,UAAA;IACA,YAAA;EA/Sd;EAiTc;IACE,0CAAA;EA/ShB;EAmTY;IACE,gBAAA;EAjTd;EAuTM;IACE,cAAA;IACA,kBAAA;IACA,qBAAA;IACA,mBAAA;IACA,kBAAA;IACA,eAAA;IACA,MAAA;IACA,QAAA;IACA,UAAA;IACA,WAAA;IACA,wCAAA;IACA,aAAA;IACA,iBAAA;IACA,4FAAA;IAMA,UAAA;IACA,qCAAA;EA1TR;EA4TQ;IAvBF;MAwBI,2BAAA;MACA,WAAA;MACA,mBAAA;MACA,kBAAA;MACA,iBAAA;MACA,oBAAA;MACA,wCAAA;IAzTR;EACF;EA6TY;IACE,mBAAA;EA3Td;EA6Tc;IACE,gBAAA;EA3ThB;EA8Tc;IACE,eAAA;EA5ThB;EAkUQ;IACE,cAAA;IACA,cAAA;IACA,YAAA;IACA,UAAA;EAhUV;EAkUU;IACE,iBAAA;IACA,oBAAA;IACA,iDAAA;EAhUZ;EAkUY;IACE,gBAAA;EAhUd;EAmUY;IACE,uBAAA;IACA,eAAA;EAjUd;EAoUY;IACE,YAAA;IACA,SAAA;EAlUd;EAuUQ;IACE,kBAAA;IACA,SAAA;IACA,WAAA;EArUV;EAwUQ;IACE,6BAAA;IACA,kBAAA;EAtUV;EAwUU;IACE,cAAA;IACA,YAAA;IACA,eAAA;IACA,mBAAA;EAtUZ;EAyUU;IACE,cAAA;IACA,oBAAA;IACA,gBAAA;EAvUZ;EAyUY;IACE,eAAA;IACA,mBAAA;IACA,kBAAA;EAvUd;EAyUc;IACE,0CAAA;EAvUhB;EA6UQ;IACE,uBAAA;EA3UV;EA6UU;IACE,gBAAA;IACA,mBAAA;EA3UZ;EA6UY;IACE,gBAAA;EA3Ud;EA8UY;IACE,eAAA;IACA,mBAAA;IACA,SAAA;IACA,UAAA;EA5Ud;EA8Uc;IACE,0BAAA;IACA,+BAAA;EA5UhB;EAgVY;IACE,+BAAA;EA9Ud;EAiVY;IACE,gBAAA;IACA,mBAAA;EA/Ud;EAwVM;;;;IAEE,aAAA;IACA,kBAAA;IACA,WAAA;IACA,gBAAA;IACA,wBAAA;IACA,OAAA;IACA,sBAAA;EApVR;EAsVQ;;;;IACE,UAAA;EAjVV;EAmVU;;;;;;;;;;IAEE,OAAA;IACA,UAAA;EAzUZ;EA4UU;;;;IACE,cAAA;EAvUZ;EAyUY;;;;IACE,aAAA;EApUd;EAyUQ;;;;IACE,qBAAA;IACA,eAAA;IACA,kBAAA;EApUV;EAyUQ;IACE,cAAA;EAvUV;EA0UQ;IACE,cAAA;IACA,gBAAA;IACA,mBAAA;EAxUV;EA4UY;IAFF;MAGI,aAAA;IAzUZ;EACF;EA2UY;IANF;MAOI,aAAA;IAxUZ;EACF;EA0UY;IAVF;MAWI,aAAA;IAvUZ;EACF;EA0UU;IACE,gBAAA;EAxUZ;EA2UU;IACE,gBAAA;IACA,UAAA;EAzUZ;EA8UM;;;;IAEE,gBAAA;EA1UR;EA4UQ;;;;IACE,mBAAA;EAvUV;EAyUU;;;;IACE,cAAA;EApUZ;EA0UI;IACE,uBAAA;EAxUN;EA0UM;IAHF;MAII,uBAAA;IAvUN;EACF;EA0UQ;IACE,gBAAA;IACA,mBAAA;IACA,eAAA;IACA,iBAAA;IACA,cAAA;IACA,SAAA;EAxUV;EA4UU;IACE,kBAAA;EA1UZ;EA6UU;IACE,aAAA;IACA,kBAAA;IACA,MAAA;IACA,QAAA;IACA,yBAAA;IACA,mBAAA;IACA,iBAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,cAAA;EA3UZ;EAgVY;;;;IAEE,cAAA;IACA,UAAA;IACA,mBAAA;IACA,kBAAA;IACA,iBAAA;IACA,mCAAA;EA5Ud;AACF;AAsVE;EAt/CF;IA2/CI,QAAA;EAvVF;AACF;AAyVE;EA9/CF;IAggDI,QAAA;EAvVF;AACF;;AA4VE;EACE,4BAAA;AAzVJ;AA2VI;EACE,wBAAA;AAzVN;;AAkWM;EACE,wBAAA;AA/VR;AAsWM;EACE,aAAA;AApWR;AAuWM;EACE,qBAAA;EACA,cAAA;AArWR;AA4WM;EACE,gBAAA;AA1WR;AA+WM;EACE,cAAA;AA7WR;AA+WQ;EACE,gBAAA;AA7WV;AAmXE;EACE,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uCAAA;AAjXJ;AAqXI;EACE,6BAAA;AAnXN;;AAyXA;EACE,sBAAA;EACA,UAAA;AAtXF;AA4XU;EACE,yBAAA;AA1XZ;AA8XQ;EACE,cAAA;AA5XV;AA8XU;EACE,oCAAA;AA5XZ;AAkYI;EACE,WAAA;AAhYN;AAoYE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AAlYJ;AAoYI;EAbF;IAcI,MAAA;IACA,QAAA;EAjYJ;AACF;AAoYE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,QAAA;AAlYJ;AAqYE;EACE,eAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;AAnYJ;AAqYI;EACE,QAAA;AAnYN;AAsYI;EACE,WAAA;EACA,WAAA;AApYN;AAsYM;EACE,OAAA;AApYR;;AA0YA,yBAAA;AACA;EACE,cAAA;AAvYF;;AA0YA;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAvYF;AAyYE;EACE,gBAAA;AAvYJ;AA0YE;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;AAxYJ;AA0YI;EACE,MAAA;EACA,WAAA;AAxYN;AA2YI;EAEE,QAAA;AA1YN;AA6YI;EACE,SAAA;EACA,WAAA;AA3YN;AAiZM;EACE,QAAA;EACA,SAAA;AA/YR;AAkZM;EACE,wBAAA;AAhZR;AAmZM;EACE,yBAAA;AAjZR;AAoZM;EACE,QAAA;EACA,SAAA;AAlZR;;AAwZA;EACE,yBAAA;AArZF;;AA0ZE;EACE,cAAA;EACA,aAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,wDAAA;AAvZJ;AAyZI;EACE,UAAA;EACA,mBAAA;AAvZN;AAyZM;EACE,YAAA;EACA,wBAAA;AAvZR;AA2ZI;EACE,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAzZN;AA2ZM;EApBF;IAqBI,QAAA;IACA,UAAA;EAxZN;AACF;AA2ZI;EACE,4BAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;AAzZN;AA2ZM;EACE,UAAA;EACA,kBAAA;AAzZR;AA2ZQ;EAJF;IAKI,UAAA;EAxZR;AACF;AA0ZQ;EARF;IASI,UAAA;EAvZR;AACF;AAyZQ;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;AAvZV;AAyZU;EAZF;IAaI,iBAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;IACA,mBAAA;IACA,iBAAA;EAtZV;AACF;AA0ZU;EACE,cAAA;AAxZZ;AA8ZI;EACE,cAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AA5ZN;AA8ZM;EACE,gBAAA;AA5ZR;;AAkaA;EACE,mBAAA;AA/ZF;;AAmaA;EACE,kBAAA;EACA,mBAAA;AAhaF;AAkaE;EAJF;IAKI,kBAAA;IACA,mBAAA;EA/ZF;AACF;;AAoaI;EACE,4BAAA;AAjaN;AAmaM;EAHF;IAII,2BAAA;EAhaN;AACF;AAkaM;EACE,kBAAA;AAhaR;;AA0aM;EACE,eAAA;AAvaR","sourcesContent":["body {\n  &.mobile-menu {\n    transition: var(--default-transition);\n  }\n\n  &.navbar-collapse-show {\n    &.mobile-menu {\n      transition-delay: 0.3s;\n    }\n\n    header {\n      &.reverse-scroll {\n        &.sticky-header {\n          transform: translateY(0);\n        }\n      }\n    }\n  }\n}\n\nheader {\n  .top-bar {\n    transition: var(--default-transition);\n  }\n\n  .dropdown {\n    .dropdown-menu {\n      opacity: 0;\n      padding: 15px;\n      visibility: hidden;\n      box-shadow: 0 0 35px rgb(0, 0, 0, 0.1);\n      transition: var(--default-transition);\n\n      a {\n        display: flex;\n        align-items: center;\n\n        span {\n          display: inline-block;\n          margin-right: 10px;\n        }\n      }\n    }\n\n    &:hover {\n      .dropdown-menu {\n        opacity: 1;\n        visibility: visible;\n      }\n    }\n  }\n\n  .header-search-iconbar {\n    >a {\n      color: #232323;\n      cursor: pointer;\n      transition: var(--default-transition);\n\n      &:hover {\n        color: rgba(0, 0, 0, 0.6);\n      }\n    }\n  }\n\n  .header-language {\n    position: relative;\n\n    >a {\n      color: #232323;\n      cursor: pointer;\n      transition: var(--default-transition);\n\n      &:hover {\n        color: rgba(0, 0, 0, 0.6);\n      }\n    }\n\n    .dropdown-menu {\n      a {\n        font-size: 12px;\n        line-height: 30px;\n        padding: 2px 0;\n        color: #828282;\n        transition: var(--default-transition);\n\n        &:hover {\n          color: #232323;\n        }\n\n        span {\n          width: 16px;\n          height: 16px;\n          display: inline-block;\n          margin: 0 10px 0 5px;\n        }\n      }\n\n      &.show {\n        opacity: 1;\n        visibility: visible\n      }\n    }\n  }\n\n  .header-cart-icon {\n    position: relative;\n\n    >a {\n      color: #232323;\n      transition: var(--default-transition);\n    }\n\n    .cart-item-list {\n      left: auto;\n      right: 0;\n      border-radius: 4px;\n      border: 0;\n      padding: 0;\n      margin: 0;\n      min-width: 250px;\n      box-shadow: 0 0 35px rgb(0 0 0 / 10%);\n\n      .cart-item {\n        display: flex;\n        position: relative;\n        border-color: #ededed;\n        border-bottom-width: 1px;\n        padding: 17px;\n\n        &:last-child {\n          border-bottom: none;\n          border-radius: 0 0 6px 6px;\n        }\n\n        >.close {\n          color: #838383;\n          font-size: 16px;\n          line-height: 15px;\n          position: absolute;\n          color: #838383;\n          right: 15px;\n          top: 15px;\n          font-weight: 400;\n          transition: var(--default-transition);\n\n          &:hover {\n            color: #232323;\n          }\n        }\n\n        .product-image {\n          max-width: 50px;\n          width: 30%;\n          display: inline-block;\n        }\n\n        .product-detail {\n          display: inline-block;\n          width: 70%;\n          padding-left: 15px;\n\n          >a {\n            line-height: 16px;\n            display: inline-block;\n            color: #232323;\n            font-size: 12px;\n            line-height: 16px;\n          }\n\n          .item-ammount {\n            display: block;\n            font-size: 11px;\n            line-height: 14px;\n            color: #828282;\n            line-height: 1.5;\n          }\n        }\n      }\n\n      .cart-total {\n        flex-direction: column;\n        background-color: #f7f7f7;\n\n        .btn {\n          display: block;\n          width: 100%;\n          margin-top: 4px;\n          margin-bottom: 4px;\n        }\n      }\n    }\n\n    >a {\n      &:hover {\n        color: rgba(35, 35, 35, 0.6);\n        cursor: pointer;\n      }\n    }\n  }\n\n  [class^=\"container-\"] [class*=\" col-\"],\n  [class^=\"container-\"] [class^=\"col-\"],\n  [class*=\" container-\"] [class*=\" col-\"],\n  [class*=\" container-\"] [class^=\"col-\"] {\n    padding-right: 15px;\n    padding-left: 15px;\n    position: relative;\n  }\n\n  .nav-item {\n    position: relative;\n    font-family: var(--alt-font);\n    font-size: 14px;\n    line-height: 20px;\n\n    >i {\n      display: none;\n    }\n\n    &:hover {\n      .megamenu {\n        opacity: 1;\n        visibility: visible;\n      }\n\n      >.simple-dropdown-menu {\n        opacity: 1;\n        visibility: visible;\n\n        >li {\n          &:hover {\n            >.simple-dropdown-menu {\n              opacity: 1;\n              visibility: visible;\n\n              >li {\n                &:hover {\n                  >.simple-dropdown-menu {\n                    opacity: 1;\n                    visibility: visible;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .simple-dropdown-menu {\n      background-color: #fff;\n      box-sizing: border-box;\n      z-index: 10;\n      left: 0;\n      top: 100%;\n      position: absolute;\n      font-weight: 500;\n      font-size: 13px;\n      line-height: 22px;\n      opacity: 0;\n      visibility: hidden;\n      line-height: 20px;\n      width: 240px;\n      padding: 25px 0;\n      box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);\n      border-radius: 4px;\n      border: 0;\n      transition: none;\n\n      li {\n        padding: 9px 0 9px 35px;\n        position: relative;\n        display: block;\n\n        >.nav-link {\n          cursor: pointer;\n          padding: 0;\n          display: block;\n\n          >i {\n            top: 50%;\n            margin-top: 0;\n            position: absolute;\n            text-align: center;\n            transform: translateY(-50%);\n            display: inline-block;\n            right: 23px;\n            font-size: 12px;\n            height: 20px;\n            width: 20px;\n            line-height: 20px;\n            transition: var(--default-transition);\n          }\n\n          &:hover {\n            color: #232323;\n          }\n        }\n\n        >.simple-dropdown-menu {\n          transform: translateX(0);\n          top: 0;\n          left: 100%;\n\n          &.menu-left {\n            right: 100%;\n            left: auto !important;\n          }\n        }\n      }\n\n      .simple-dropdown {\n        &.active {\n          >.nav-link {\n            color: #232323;\n          }\n        }\n      }\n    }\n\n    .nav-link {\n      color: #828282;\n\n      &.active {\n        color: #232323;\n      }\n    }\n  }\n\n  .navbar-nav {\n    display: flex;\n    justify-content: center;\n\n    >.nav-item {\n      >.nav-link {\n        padding: 30px 0;\n        margin: 0 18px;\n        word-break: normal;\n        font-weight: 500;\n        color: #232323;\n        transition: var(--default-transition);\n      }\n\n      &.active {\n        >.nav-link {\n          opacity: 0.7;\n        }\n      }\n    }\n\n    // Megamenu\n    .megamenu {\n      box-sizing: border-box;\n      background-color: #fff;\n      z-index: 10;\n      top: 100%;\n      position: absolute;\n      left: 0;\n      transform: inherit;\n      opacity: 0;\n      visibility: hidden;\n      padding: 60px 80px;\n      box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);\n      border-radius: 4px;\n      border: 0;\n      transition: 0s;\n\n      ul {\n        padding-right: 90px;\n\n        .title {\n          color: #232323;\n        }\n\n        &:last-child {\n          padding-right: 50px;\n        }\n\n        @media (max-width:var(--lg)) {\n          padding-right: 75px;\n        }\n      }\n\n      .nav-item {\n        .nav-link {\n          display: flex;\n          overflow: hidden;\n          position: relative;\n          padding: 0;\n          font-family: var(--alt-font);\n          font-size: 13px;\n          line-height: 22px;\n          font-weight: 500;\n          text-align: left;\n          align-items: center;\n          white-space: nowrap;\n          color: #828282;\n          margin: 0 0 5px 0;\n          line-height: 30px;\n          transition: var(--default-transition);\n\n          &:hover {\n            color: #232323;\n          }\n        }\n\n        &.active {\n          >.nav-link {\n            color: #232323;\n          }\n        }\n      }\n\n      @media (max-width:var(--lg)) {\n        padding: 35px 50px 40px;\n      }\n    }\n\n    // Submenu\n    .submenu {\n      .nav-link {\n        padding: 0;\n\n        &:hover {\n          color: #232323;\n        }\n      }\n    }\n  }\n\n  .navbar-brand {\n    img {\n      max-height: 36px;\n    }\n\n    .default-logo {\n      visibility: visible;\n      opacity: 1;\n      width: auto;\n      transition-duration: 0.5s;\n    }\n\n    .alt-logo {\n      visibility: hidden;\n      opacity: 0;\n      width: 0;\n      transition-duration: 0.5s;\n    }\n\n    .mobile-logo {\n      visibility: hidden;\n      opacity: 0;\n      width: 0;\n      transition-duration: 0.5s;\n    }\n  }\n\n  // Theme\n  .navbar-dark,\n  .navbar-lg-dark,\n  .navbar-md-dark,\n  .navbar-sm-dark,\n  .navbar-xs-dark,\n  .navbar-xl-dark,\n  .navbar-xxl-dark {\n    .navbar-nav {\n      >.nav-item {\n        >.nav-link {\n          color: #fff;\n\n          &:hover {\n            opacity: 0.6;\n          }\n        }\n      }\n    }\n\n    // Icons\n    .header-search-iconbar,\n    .header-language,\n    .header-cart-icon {\n      >a {\n        color: #fff;\n        display: inline-block;\n        vertical-align: middle;\n        min-height: 20px;\n        width: 20px;\n\n        &:hover {\n          color: rgba(255, 255, 255, 0.6);\n        }\n      }\n    }\n\n    .navbar-toggler {\n      .navbar-toggler-line {\n        background-color: #fff;\n      }\n    }\n  }\n\n  // Menu\n  .menu-dark {\n    .megamenu {\n      background-color: #232323;\n\n      ul {\n        .title {\n          color: #fff;\n        }\n      }\n\n      .nav-item {\n        .nav-link {\n          &:hover {\n            color: #fff;\n          }\n        }\n\n        &.active {\n          .nav-link {\n            color: #fff;\n          }\n        }\n      }\n    }\n\n    .simple-dropdown-menu,\n    .dropdown-menu {\n      background-color: #232323;\n\n      >li {\n        .nav-link {\n          transition: var(--default-transition);\n\n          &:hover {\n            color: #fff;\n          }\n        }\n\n        a {\n          transition: var(--default-transition);\n\n          &:hover {\n            color: #fff;\n          }\n        }\n      }\n    }\n  }\n\n  .collapsible-menu {\n    font-family: var(--alt-font);\n\n    .accordion-item {\n      border: none;\n      background-color: transparent;\n\n      &:hover,\n      &.active {\n        >.accordion-header {\n          .accordion-button {\n            color: rgba(0, 0, 0, 0.6);\n          }\n        }\n      }\n\n      .img-wrapper {\n        border-style: none;\n        display: none;\n      }\n\n      .accordion-header {\n        .accordion-button {\n          font-family: var(--alt-font);\n          font-size: 20px;\n          line-height: 1.5;\n          color: #232323;\n          padding: 13px 0;\n\n          &::after {\n            overflow: hidden;\n            display: none;\n          }\n\n          &:hover {\n\n            span,\n            a {\n              transition: all 0.3s ease-in-out;\n            }\n          }\n\n          .icon {\n            display: inline-block;\n            margin-left: auto;\n            position: relative;\n            width: 30px;\n            height: 30px;\n\n            &:before,\n            &:after {\n              background-color: #232323;\n              position: absolute;\n              top: 50%;\n              content: \"\";\n              width: 11px;\n              height: 1px;\n              left: 10px;\n              transition: var(--default-transition);\n            }\n\n            &::after {\n              background-image: none;\n              transform: rotate(90deg);\n            }\n          }\n\n          &:not(.collapsed) {\n            box-shadow: none;\n            background-color: transparent;\n\n            >.icon {\n              &::after {\n                transform: rotate(0deg);\n              }\n\n              &:before {\n                background-color: transparent;\n              }\n            }\n          }\n        }\n      }\n\n      .accordion-collapse {\n        .accordion-body {\n          color: rgba(0, 0, 0, 0.6);\n          padding: 5px 0;\n          font-size: 13px;\n          line-height: 22px;\n\n          i {\n            display: inline-block;\n            vertical-align: middle;\n            margin-right: 10px;\n          }\n\n          .accordion-button {\n            font-size: 13px;\n            padding: 0;\n            line-height: 22px;\n            line-height: 30px;\n          }\n        }\n      }\n    }\n\n    .menu-list {\n      padding-left: 15px;\n\n      .menu-list-item {\n        line-height: 30px;\n\n        a {\n          color: #00000099;\n\n          &:hover {\n            color: #00000099;\n          }\n        }\n\n        &.active {\n          a {\n            color: rgba(0, 0, 0, 0.3);\n          }\n        }\n      }\n    }\n\n    .megamenu {\n      .accordion {\n        .accordion-item {\n          border: 0px !important;\n\n          &:hover {\n            .accordion-header {\n              .accordion-button {\n                color: #828282 !important;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .single-dropdown {\n      a.menu-link {\n        color: rgba(0, 0, 0, 0.6);\n\n        &:hover {\n          color: rgba(0, 0, 0, 0.3);\n        }\n      }\n\n      .accordion {\n        >.accordion-item {\n          border: 0px !important;\n        }\n      }\n\n      .accordion-item {\n        .accordion-item {\n          a.menu-link {\n            padding-left: 15px;\n          }\n        }\n      }\n    }\n\n    .footer-holder {\n      .social-icon {\n        li {\n          a {\n            &:hover {\n              transform: translateY(0px);\n            }\n          }\n        }\n      }\n    }\n\n    &.light {\n      .menu-list {\n        .menu-list-item {\n          a {\n            color: rgba(255, 255, 255, 0.6);\n          }\n\n          &.active {\n            a {\n              color: rgba(255, 255, 255, 0.3);\n            }\n          }\n        }\n      }\n\n      .accordion-item {\n        .accordion-header {\n          .accordion-button {\n            color: #fff;\n\n            .icon {\n\n              &::after,\n              &::before {\n                background-color: #fff;\n              }\n            }\n          }\n        }\n\n        &.active,\n        &:hover {\n          >.accordion-header {\n            .accordion-button {\n              color: rgba(255, 255, 255, 0.5);\n            }\n          }\n        }\n      }\n\n      .single-dropdown {\n        .menu-list-item {\n          &.active {\n            a.menu-link {\n              color: rgba(255, 255, 255, 0.3);\n            }\n          }\n        }\n\n        a.menu-link {\n          color: rgba(255, 255, 255, 0.6);\n        }\n      }\n    }\n  }\n\n  // Types\n  &.always-fixed {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 10;\n\n    &.sticky-header {\n      transform: translateY(0);\n    }\n  }\n\n  &.reverse-scroll {\n    width: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 15;\n    transition: var(--default-transition);\n\n    &.sticky-header {\n      transform: translateY(-100%);\n      box-shadow: none;\n\n      &.header-appear {\n        background-color: #fff;\n        transform: translateY(0);\n        box-shadow: 0 0 35px rgb(0 0 0 / 10%);\n\n        .alt-logo {\n          visibility: visible;\n          opacity: 1;\n          width: auto;\n        }\n\n        .default-logo {\n          opacity: 0;\n          visibility: hidden;\n          width: 0;\n        }\n\n        .menu-light {\n\n          // Icons\n          .header-search-iconbar,\n          .header-language,\n          .header-cart-icon,\n          .nav-bar-contact {\n            >a {\n              color: #232323;\n\n              &:hover {\n                color: rgba(35, 35, 35, 0.6);\n              }\n            }\n          }\n\n          .social-icon.light {\n            a {\n              color: #232323;\n\n              &:hover {\n                color: rgba(35, 35, 35, 0.6);\n              }\n            }\n          }\n\n          &.bg-dark,\n          &.bg-black {\n\n            // Icons\n            .header-search-iconbar,\n            .header-language,\n            .header-cart-icon {\n              >a {\n                color: #fff;\n\n                &:hover {\n                  color: rgba(255, 255, 255, 0.6);\n                }\n              }\n            }\n          }\n        }\n\n        .menu-dark {\n          background-color: #fff;\n\n          &:not(.bg-light) {\n            .navbar-brand {\n              img {\n                filter: brightness(0) invert(1);\n              }\n            }\n          }\n        }\n\n        >.header-transparent {\n          .navbar-nav {\n            >.nav-item {\n              >.nav-link {\n                color: #232323;\n              }\n            }\n          }\n\n          .header-push-button {\n            .push-button {\n              span {\n                background-color: #fff;\n              }\n            }\n          }\n        }\n\n        .top-bar {\n          margin-top: calc(-1px - var(--topbar-height));\n        }\n      }\n    }\n  }\n\n  &.responsive-sticky {\n    width: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 15;\n\n    .header-search-iconbar,\n    .header-language,\n    .header-cart-icon {\n      i {\n        padding: 30px 0;\n        transition: var(--default-transition);\n      }\n    }\n\n    >.navbar-expand-lg {\n      transition: var(--default-transition);\n\n      @media (max-width:var(--md)) {\n        padding-top: 20px;\n        padding-bottom: 20px;\n      }\n    }\n\n    &.sticky-header {\n      .navbar-nav {\n        >.nav-item {\n          >.nav-link {\n            padding: 18px 0;\n          }\n        }\n      }\n\n      .header-search-iconbar,\n      .header-language,\n      .header-cart-icon {\n        i {\n          padding: 18px 0;\n        }\n      }\n\n      >.navbar-expand-lg {\n        @media (max-width:var(--md)) {\n          padding-top: 10px;\n          padding-bottom: 10px;\n\n          >.nav-item {\n            >.nav-link {\n              padding: 15px 0;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &.pos-left {\n    left: 0;\n    top: 0;\n    position: fixed;\n  }\n\n  @screen md {\n    .navbar-expand-lg {\n      &.header-transparent {\n        background-color: #fff !important;\n      }\n\n      .navbar-brand {\n\n        .default-logo,\n        .alt-logo {\n          opacity: 0 !important;\n          visibility: hidden !important;\n          width: 0 !important;\n        }\n\n        .mobile-logo {\n          opacity: 1;\n          visibility: visible;\n          width: auto;\n        }\n      }\n\n      &.navbar-dark {\n\n        .header-search-iconbar,\n        .header-language,\n        .header-cart-icon {\n\n          >a,\n          span {\n            color: #232323;\n          }\n        }\n\n        &.header-transparent {\n          .navbar-toggler {\n            .navbar-toggler-line {\n              background-color: #232323;\n            }\n          }\n\n          .social-icon {\n            &.light {\n              a {\n                color: #232323;\n              }\n            }\n          }\n        }\n\n        &.bg-dark,\n        &.bg-black {\n\n          .header-search-iconbar,\n          .header-language,\n          .header-cart-icon {\n            >a {\n              color: #fff;\n            }\n          }\n\n          .navbar-toggler {\n            .navbar-toggler-line {\n              background-color: #fff;\n            }\n          }\n        }\n      }\n\n      &.menu-dark {\n        .navbar-collapse {\n          background-color: #fff;\n        }\n\n        .navbar-nav>.nav-item>.nav-link {\n          color: #fff;\n        }\n      }\n\n      .navbar-collapse {\n        overflow: hidden;\n        position: absolute;\n        left: 0;\n        top: 100%;\n        width: 100%;\n        background-color: #fff;\n        box-shadow: 0 20px 15px 0 rgb(23 23 23 / 5%);\n        max-height: calc(100vh - 65px);\n\n        @media (max-width:var(--sm)) {\n          padding: 0;\n        }\n\n        &.show {\n          overflow-y: auto;\n\n          &.mobile-menu-full {\n            transform: translateY(0);\n\n            .navbar-nav {\n              >.nav-item {\n                .megamenu {\n                  >.nav-item {}\n                }\n\n                >.nav-link {\n                  padding-top: 6px;\n                  padding-bottom: 6px;\n                }\n              }\n            }\n\n            .navbar-nav {\n              .nav-item {\n                &:last-child {\n                  border-bottom: 0px;\n                }\n              }\n            }\n          }\n\n          &.mobile-menu-modern {\n            padding-top: 94px;\n            padding-bottom: 75px;\n            transform: translateX(0);\n            padding-left: 12vw;\n            padding-right: 12vw;\n\n            @media (max-width:var(--xs)) {\n              padding-left: 10vw;\n              padding-right: 10vw;\n            }\n          }\n        }\n\n        &:not(.show) {\n          &.mobile-menu-modern {\n            transition-delay: 0.1s;\n          }\n        }\n\n        // Mobile Menu Types\n        &.mobile-menu-full {\n          position: fixed;\n          top: 0;\n          left: 0;\n          width: 100%;\n          padding: 100px 70px;\n          height: 100vh;\n          max-height: 100vh;\n          background-image: linear-gradient(to right top,\n              #0039e3,\n              #4132e0,\n              #5e28dd,\n              #741bd9,\n              #8600d4);\n          z-index: 1;\n          display: block !important;\n          transform: translateY(-100%);\n          transition: var(--default-transition);\n\n          @media (max-width:var(--sm)) {\n            padding: 70px;\n          }\n\n          @media (max-width:var(--xs)) {\n            padding: 50px;\n            padding-bottom: 70px;\n            padding-right: 35px;\n          }\n\n          .dropdown {\n            >.simple-dropdown-menu {\n              >.simple-dropdown {\n                >.nav-link {\n                  color: white !important;\n                  opacity: 0.7 !important;\n                  font-size: 14px;\n                }\n              }\n            }\n          }\n\n          .navbar-nav {\n            display: block;\n            overflow: auto;\n            height: 100%;\n            padding-left: 25px;\n            padding-right: 25px;\n\n            @media (max-width:var(--xs)) {\n              padding-left: 5px;\n              padding-right: 5px;\n            }\n\n            .nav-item {\n              padding-top: 10px;\n              padding-bottom: 12px;\n              border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n              text-align: left;\n\n              .nav-link {\n                color: white !important;\n                font-size: 17px;\n\n                &.active {\n                  color: rgba(255, 255, 255, 0.6) !important;\n                }\n              }\n\n              i {\n                font-size: 17px;\n                color: white !important;\n                top: 7px;\n              }\n            }\n          }\n\n          .navbar-toggler {\n            position: absolute;\n            top: 30px;\n            right: 30px;\n          }\n\n          .megamenu {\n            background-color: transparent;\n            left: 0 !important;\n\n            .title {\n              opacity: 0.7;\n              padding-bottom: 12px;\n              margin-bottom: 4px;\n              color: #fff;\n              font-size: 12px;\n            }\n\n            .nav-item {\n              padding-bottom: 12px;\n              padding-top: 0;\n              border-bottom: 0;\n\n              .nav-link {\n                font-size: 13px;\n                line-height: normal;\n                margin-bottom: 5px;\n              }\n            }\n          }\n\n          .simple-dropdown-menu {\n            background-color: transparent;\n            left: 0 !important;\n\n            .simple-dropdown>.nav-link {\n              color: #ffffff;\n              padding-bottom: 12px;\n              font-size: 15px;\n              margin-bottom: 4px;\n            }\n\n            .simple-dropdown {\n              border-bottom: 0;\n              padding-bottom: 12px;\n\n              >.nav-link {\n                font-size: 13px;\n                line-height: normal;\n                margin: 0;\n                padding: 0;\n                color: white;\n\n                &.active {\n                  color: rgba(255, 255, 255, .6) !important;\n                }\n              }\n\n              .simple-dropdown-menu {\n                margin-top: 15px;\n              }\n            }\n          }\n        }\n\n        &.mobile-menu-modern {\n          display: block;\n          padding-top: 100px;\n          padding-bottom: 100px;\n          padding-right: 12vw;\n          padding-left: 12vW;\n          position: fixed;\n          top: 0;\n          right: 0;\n          left: auto;\n          width: 70vw;\n          transform: translateX(calc(70vw + 10px));\n          height: 100vh;\n          max-height: 100vh;\n          background-image: linear-gradient(to right top,\n              #0039e3,\n              #4132e0,\n              #5e28dd,\n              #741bd9,\n              #8600d4);\n          z-index: 1;\n          transition: var(--default-transition);\n\n          @media (max-width:var(--xs)) {\n            transform: translateX(70vw);\n            width: 85vw;\n            padding-right: 10vw;\n            padding-left: 10vW;\n            padding-top: 30px;\n            padding-bottom: 30px;\n            transform: translateX(calc(85vw + 10px));\n          }\n\n          .dropdown {\n            >.simple-dropdown-menu {\n              >.simple-dropdown {\n                margin-bottom: 25px;\n\n                &:last-child {\n                  margin-bottom: 0;\n                }\n\n                >.nav-link {\n                  font-size: 14px;\n                }\n              }\n            }\n          }\n\n          .navbar-nav {\n            display: block;\n            overflow: auto;\n            height: 100%;\n            padding: 0;\n\n            .nav-item {\n              padding-top: 10px;\n              padding-bottom: 12px;\n              border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n              &:last-child {\n                border-bottom: 0;\n              }\n\n              .nav-link {\n                color: white !important;\n                font-size: 17px;\n              }\n\n              i {\n                color: white;\n                top: 10px;\n              }\n            }\n          }\n\n          .navbar-toggler {\n            position: absolute;\n            top: 30px;\n            right: 30px;\n          }\n\n          .megamenu {\n            background-color: transparent;\n            left: 0 !important;\n\n            .title {\n              color: #ffffff;\n              opacity: 0.7;\n              font-size: 15px;\n              margin-bottom: 15px;\n            }\n\n            .nav-item {\n              padding-top: 0;\n              padding-bottom: 10px;\n              border-bottom: 0;\n\n              .nav-link {\n                font-size: 13px;\n                line-height: normal;\n                margin-bottom: 5px;\n\n                &.active {\n                  color: rgba(255, 255, 255, .6) !important;\n                }\n              }\n            }\n          }\n\n          .simple-dropdown-menu {\n            background: transparent;\n\n            .simple-dropdown {\n              border-bottom: 0;\n              margin-bottom: 10px;\n\n              &:last-child {\n                margin-bottom: 0;\n              }\n\n              >.nav-link {\n                font-size: 13px;\n                line-height: normal;\n                margin: 0;\n                padding: 0;\n\n                &.active {\n                  text-decoration: underline;\n                  color: rgba(255, 255, 255, 0.7);\n                }\n              }\n\n              >span.nav-link {\n                color: rgba(255, 255, 255, 0.7);\n              }\n\n              .simple-dropdown-menu {\n                margin-top: 10px;\n                margin-bottom: 25px;\n              }\n            }\n          }\n        }\n      }\n\n      .nav-item {\n\n        .simple-dropdown-menu,\n        .megamenu {\n          display: none;\n          position: relative;\n          width: 100%;\n          box-shadow: none;\n          transform: translateX(0);\n          left: 0;\n          padding: 0 0 20px 15px;\n\n          li {\n            padding: 0;\n\n            >.simple-dropdown-menu,\n            >.megamenu {\n              left: 0;\n              padding: 0;\n            }\n\n            >span {\n              color: #232323;\n\n              i {\n                display: none;\n              }\n            }\n          }\n\n          .nav-link {\n            padding: 3px 15px 3px;\n            font-size: 14px;\n            margin-bottom: 5px;\n          }\n        }\n\n        .megamenu {\n          >div {\n            display: block;\n          }\n\n          ul {\n            display: block;\n            padding-right: 0;\n            margin-bottom: 20px;\n\n            &.img-wrapper {\n\n              @media (max-width:var(--md)) {\n                display: none;\n              }\n\n              @media (max-width:var(--sm)) {\n                display: none;\n              }\n\n              @media (max-width:var(--xs)) {\n                display: none;\n              }\n            }\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n\n            .nav-link {\n              margin-bottom: 0;\n              padding: 0;\n            }\n          }\n        }\n\n        >.simple-dropdown-menu,\n        >.megamenu {\n          margin-top: 10px;\n\n          >.simple-dropdown {\n            margin-bottom: 10px;\n\n            >a {\n              color: #232323;\n            }\n          }\n        }\n      }\n\n      .navbar-nav {\n        padding: 15px 30px 25px;\n\n        @screen sm {\n          padding: 15px 15px 25px;\n        }\n\n        >.nav-item {\n          >.nav-link {\n            padding-top: 9px;\n            padding-bottom: 9px;\n            font-size: 15px;\n            line-height: 30px;\n            color: #232323;\n            margin: 0;\n          }\n\n          &.dropdown {\n            .nav-link {\n              position: relative;\n            }\n\n            >i {\n              display: flex;\n              position: absolute;\n              top: 0;\n              right: 0;\n              justify-content: flex-end;\n              align-items: center;\n              text-align: right;\n              width: 48px;\n              height: 48px;\n              font-weight: 900;\n              line-height: 1;\n            }\n\n            &.open {\n\n              .simple-dropdown-menu,\n              .megamenu {\n                display: block;\n                opacity: 1;\n                visibility: visible;\n                left: 0 !important;\n                top: 0 !important;\n                transform: translateY(0) !important;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    foo:bar;\n  }\n\n  @screen sm {\n\n    .navbar-expand-md {\n      @extend .navbar-expand-lg;\n    }\n    foo: bar;\n  }\n\n  @screen xs {\n    @extend .navbar-expand-lg;\n    foo: bar;\n  }\n}\n\n// left-menu-morden\n.left-menu-modern-sidebar {\n  .left-menu-wrapper {\n    transform: translateX(-120%);\n\n    &.show {\n      transform: translateX(0);\n    }\n  }\n}\n\n// header with top bar\n.header-with-topbar {\n  &.sticky-header {\n    &.header-appear {\n      &.reverse-scroll {\n        transform: translateY(0);\n      }\n    }\n  }\n\n  .dropdown {\n    >button {\n      &::after {\n        display: none;\n      }\n\n      &:hover {\n        border-color: inherit;\n        color: inherit;\n      }\n    }\n  }\n\n  .show {\n    >.btn-success.dropdown-toggle {\n      &:focus {\n        box-shadow: none;\n      }\n    }\n\n    >.btn-primary {\n      &.dropdown-toggle {\n        color: #828282;\n\n        &:focus {\n          box-shadow: none;\n        }\n      }\n    }\n  }\n\n  .dropdown-menu {\n    left: auto;\n    background-color: #ffffff;\n    border-radius: 6px;\n    border-style: none;\n    text-align: left;\n    padding: 15px;\n    box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);\n  }\n\n  .dropdown-items {\n    &:hover {\n      background-color: transparent;\n    }\n  }\n}\n\n//hamburger-menu\n.header-push-button {\n  vertical-align: middle;\n  padding: 0;\n\n  &.dark {\n    .splitportfolio-header {\n      li {\n        &:hover {\n          a {\n            color: #00000099;\n          }\n        }\n\n        a {\n          color: #232323;\n\n          &::before {\n            background-color: #00000099\n          }\n        }\n      }\n    }\n\n    .close-btn {\n      color: #000;\n    }\n  }\n\n  .close-btn {\n    position: absolute;\n    font-size: 16px;\n    color: #fff;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 50;\n    top: 20px;\n    right: 20px;\n\n    @media (max-width:var(--xs)) {\n      top: 0;\n      right: 0;\n    }\n  }\n\n  .push-button {\n    position: relative;\n    width: 22px;\n    height: 14px;\n    display: block;\n    top: 1px;\n  }\n\n  .hamburger-menu-wrapper {\n    position: fixed;\n    top: 0;\n    right: -110%;\n    height: 100vh;\n    transition: var(--default-transition);\n\n    &.show {\n      right: 0;\n    }\n\n    &.pos-left {\n      right: auto;\n      left: -110%;\n\n      &.show {\n        left: 0;\n      }\n    }\n  }\n}\n\n/* Hamburger Menu Button*/\n.navbar-expand .navbar-toggler {\n  display: block;\n}\n\n.navbar-toggler {\n  display: inline-block;\n  position: relative;\n  padding: 0;\n  vertical-align: middle;\n  border-radius: 0;\n  font-size: 24px;\n  width: 22px;\n  height: 14px;\n  border: none;\n\n  &:focus {\n    box-shadow: none;\n  }\n\n  .navbar-toggler-line {\n    display: block;\n    position: absolute;\n    right: 0;\n    left: 0;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 0;\n    background-color: #232323;\n    transform: rotate(0);\n    content: \"\";\n    height: 2px;\n    width: 22px;\n    transition: 0.25s ease-in-out;\n\n    &:nth-child(1) {\n      top: 0;\n      width: 14px;\n    }\n\n    &:nth-child(2),\n    &:nth-child(3) {\n      top: 6px;\n    }\n\n    &:nth-child(4) {\n      top: 12px;\n      width: 14px;\n    }\n  }\n\n  &:not(.collapsed) {\n    .navbar-toggler-line {\n      &:nth-child(1) {\n        top: 7px;\n        width: 0%;\n      }\n\n      &:nth-child(2) {\n        transform: rotate(45deg);\n      }\n\n      &:nth-child(3) {\n        transform: rotate(-45deg);\n      }\n\n      &:nth-child(4) {\n        top: 7px;\n        width: 0%;\n      }\n    }\n  }\n}\n\n.navbar-expand .navbar-toggler {\n  border-color: transparent;\n}\n\n// Search icons\n.header-search-iconbar {\n  .form-wrapper {\n    display: block;\n    height: 100vh;\n    left: 0;\n    opacity: 0;\n    overflow: hidden;\n    position: fixed;\n    top: 0;\n    transition: all .2s ease-in-out;\n    visibility: hidden;\n    width: 100%;\n    z-index: 999;\n    background-color: #232323e6;\n    cursor: url('../../img/mfg-close.png'), pointer;\n\n    &.show {\n      opacity: 1;\n      visibility: visible;\n\n      .search-form {\n        cursor: auto;\n        transform: translateY(0);\n      }\n    }\n\n    .search-close {\n      outline: 2px solid transparent;\n      outline-offset: 2px;\n      display: block;\n      z-index: 1046;\n      line-height: 44px;\n      overflow: visible;\n      position: fixed;\n      padding: 0;\n      color: #000000;\n      font-weight: 300;\n      border-style: none;\n      cursor: pointer;\n      outline: 0;\n      top: 30px;\n      right: 35px;\n      font-size: 30px;\n      width: 44px;\n      height: 44px;\n\n      @media (max-height:var(--xs)) {\n        top: 5px;\n        right: 5px;\n      }\n    }\n\n    .search-form {\n      transform: translateY(-100%);\n      display: flex;\n      position: absolute;\n      top: 0;\n      left: 0;\n      background-color: #ffffff;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 0;\n      height: 450px;\n      transition: all 0.4s ease-in-out;\n      cursor: auto;\n\n      .search-form-box {\n        width: 45%;\n        position: relative;\n\n        @media (max-height:var(--md)) {\n          width: 60%;\n        }\n\n        @media (max-height:var(--xs)) {\n          width: 90%;\n        }\n\n        .search-input {\n          font-weight: 300;\n          width: 100%;\n          border-radius: 0;\n          color: #232323;\n          font-size: 20px;\n          padding-top: 10px;\n          padding-right: 38px;\n          padding-bottom: 10px;\n          padding-left: 2px;\n          line-height: 40px;\n\n          @media (max-width:var(--xs)) {\n            line-height: 30px;\n            font-size: 18px;\n            padding-top: 8px;\n            padding-right: 38px;\n            padding-bottom: 8px;\n            padding-left: 2px;\n          }\n        }\n\n        input {\n          &::placeholder {\n            color: #232323;\n          }\n        }\n      }\n    }\n\n    .search-button {\n      color: #232323;\n      outline: 2px solid transparent;\n      outline-offset: 2px;\n      right: 0;\n      position: absolute;\n      cursor: pointer;\n      font-size: 15px;\n      margin-right: 0;\n      z-index: 0;\n      bottom: 19px;\n      line-height: normal;\n\n      i {\n        padding: 1px 6px;\n      }\n    }\n  }\n}\n\n.collapse {\n  visibility: visible;\n}\n\n// Mobile Modern Menu\n.menu-modern {\n  margin-left: -70vw;\n  padding-right: 70vw;\n\n  @media (max-width:var(--xs)) {\n    margin-left: -85vw;\n    padding-right: 85vw;\n  }\n}\n\n.mobile-menu {\n  header {\n    .smooth-scrollbar {\n      overflow: visible !important;\n\n      @media (max-width:var(--md)) {\n        overflow: hidden !important;\n      }\n\n      .scroll-content {\n        padding-right: 0px;\n      }\n    }\n  }\n}\n\n// toplogo\n.toplogo-header {\n  .navbar-nav {\n    >.nav-item {\n      >.nav-link {\n        padding: 25px 0;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
